// Nederlandse teksten. Elke sleutel moet ook in en.js staan (tests/i18n.mjs).
export default {
  // Navigatie
  'nav.sectie.overzicht': 'Overzicht',
  'nav.sectie.import': 'Import',
  'nav.sectie.systeem': 'Systeem',
  'nav.actiefevent': 'Editie',
  'nav.dashboard': 'Dashboard',
  'nav.teams': 'Inschrijvingen',
  'nav.activity': 'Activiteitenlog',
  'nav.flagged': 'Te controleren',
  'nav.clubs': 'Clubregister',
  'nav.leden': 'Leden',
  'nav.importcsv': 'CSV importeren',
  'nav.admins': 'Gebruikersbeheer',
  'nav.templates': 'E-mailsjablonen',
  'nav.archived': 'Archief',
  'nav.platform': 'Platformbeheer',
  'nav.settings': 'Instellingen',
  'pnav.dash': 'Overzicht',
  'pnav.orgs': 'Organisaties',
  'pnav.sectie.juridisch': 'Juridisch',
  'pnav.terms': 'Voorwaarden',
  'pnav.consent': 'Aanvaardingen',
  'pnav.instellingen': 'Instellingen',
  'pnav.sectie.koppelingen': 'Koppelingen',
  'pnav.email': 'E-mail',
  'pnav.stripe': 'Betalingen',
  'pnav.terug': 'Terug naar de organisatie',

  // Paginatitels in de bovenbalk
  'titel.dashboard': 'Dashboard',
  'titel.teams': 'Inschrijvingen',
  'titel.activity': 'Activiteitenlog',
  'titel.flagged': 'Te controleren',
  'titel.clubs': 'Clubregister',
  'titel.leden': 'Leden',
  'titel.admins': 'Gebruikersbeheer',
  'titel.templates': 'E-mailsjablonen',
  'titel.archived': 'Archief',
  'titel.settings': 'Instellingen',
  'titel.dash': 'Platformoverzicht',
  'titel.orgs': 'Organisaties',
  'titel.terms': 'Voorwaarden',
  'titel.consent': 'Aanvaardingen',
  'titel.email': 'E-mail',
  'titel.stripe': 'Betalingen',
  'titel.instellingen': 'Platforminstellingen',

  // Inloggen
  'auth.uitleg': 'Log in met je Google-account. Alleen bevoegde beheerders hebben toegang.',
  'auth.google': 'Doorgaan met Google',
  'auth.geweigerd': 'Geen toegang',
  'auth.geweigerduitleg': 'Je Google-account heeft geen toegang tot deze applicatie. Vraag de beheerder om toegang.',
  'auth.uitloggen': 'Uitloggen',

  // Standaardtabel
  'tabel.zoeken': 'Zoeken',
  'tabel.telling': '{zichtbaar} van {totaal}',
  'tabel.alleswissen': 'Alles wissen',
  'tabel.nietsgevonden': 'Niets gevonden',
  'tabel.pasaan': 'Pas je filters of zoekterm aan.',
  'tabel.leeg': 'Nog geen regels.',
  'tabel.filterkolom': 'Filter deze kolom',
  'tabel.filter': 'Filter: {kolom}',
  'tabel.filterleeg': 'Leeg',
  'tabel.filtergevuld': 'Gevuld',
  'tabel.bevat': 'Bevat…',
  'tabel.wissen': 'Wissen',
  'tabel.toepassen': 'Toepassen',
  'tabel.tagleeg': 'leeg',
  'tabel.taggevuld': 'gevuld',

  // Algemeen
  'alg.opslaan': 'Opslaan',
  'alg.annuleren': 'Annuleren',
  'alg.sluiten': 'Sluiten',
  'alg.verwijderen': 'Verwijderen',
  'alg.toevoegen': 'Toevoegen',
  'alg.ja': 'Ja',
  'alg.nee': 'Nee',
  'alg.geen': 'Geen',
  'alg.onbekend': 'Onbekend',
  'alg.laden': 'Laden…',
  'alg.fout': 'Er ging iets mis: {melding}',
  'alg.volgende': 'Volgende',
  'alg.terug': 'Terug',

  // Ledenadministratie, import en export
  "leden.nietbeschikbaar": "De ledenadministratie is voor deze organisatie nog niet beschikbaar. De databasemigratie van stap E ontbreekt of de module staat uit.",
  "leden.toevoegen": "Lid toevoegen",
  "leden.importeren": "Importeren",
  "leden.exporteren": "Exporteren",
  "leden.dubbelen": "{aantal} mogelijke dubbelen",
  "leden.status.actief": "Actief",
  "leden.status.beeindigd": "Beëindigd",
  "leden.status.geschorst": "Geschorst",
  "leden.kol.naam": "Naam",
  "leden.kol.geboortedatum": "Geboortedatum",
  "leden.kol.leeftijd": "Leeftijd",
  "leden.kol.lidnummer": "Lidnr.",
  "leden.kol.groep": "Groep",
  "leden.kol.email": "E-mail",
  "leden.kol.plaats": "Plaats",
  "leden.kol.status": "Status",
  "leden.zelfbeheer": "Zelfbeheer",
  "leden.zelfbeheer.uitleg": "Dit lid beheert zijn eigen naam, adres en contactgegevens.",
  "leden.zoek": "Zoek op naam, lidnummer, e-mail of plaats",
  "leden.leeg": "Nog geen leden. Voeg er een toe of importeer een ledenlijst.",
  "leden.veld.vast": "Ligt vast. Een correctie gaat via een verzoek aan de bond.",
  "leden.veld.persoon": "Beheert het lid zelf.",
  "leden.veld.voornaam": "Voornaam",
  "leden.veld.tussenvoegsel": "Tussenvoegsel",
  "leden.veld.achternaam": "Achternaam",
  "leden.veld.geboortedatum": "Geboortedatum",
  "leden.veld.geslacht": "Geslacht",
  "leden.veld.nationaliteiten": "Nationaliteit(en)",
  "leden.veld.email": "E-mail",
  "leden.veld.telefoon": "Telefoon",
  "leden.veld.straat": "Straat",
  "leden.veld.huisnummer": "Huisnummer",
  "leden.veld.postcode": "Postcode",
  "leden.veld.plaats": "Plaats",
  "leden.veld.land": "Land",
  "leden.veld.lidnummer": "Lidnummer",
  "leden.veld.trainingsgroep": "Trainingsgroep",
  "leden.veld.graad_opgave": "Graad (opgave club)",
  "leden.veld.notities": "Notities",
  "leden.geslacht.m": "Man",
  "leden.geslacht.v": "Vrouw",
  "leden.geslacht.x": "Anders",
  "leden.sectie.persoon": "Persoon",
  "leden.sectie.contact": "Contact en adres",
  "leden.sectie.club": "Gegevens van de club",
  "leden.sectie.lidmaatschap": "Lidmaatschap",
  "leden.sectie.ouders": "Ouders en verzorgers",
  "leden.sectie.toestemming": "Toestemmingen",
  "leden.sectie.paspoort": "Paspoort",
  "leden.lid.sinds": "Lid sinds",
  "leden.lid.status": "Status",
  "leden.lid.tot": "Tot",
  "leden.ouder.uitleg": "De club legt de relatie vast en is daarvoor verantwoordelijk. Toegang van een ouder stopt automatisch op de achttiende verjaardag.",
  "leden.ouder.geen": "Geen ouders of verzorgers vastgelegd.",
  "leden.ouder.naam": "Naam ouder of verzorger",
  "leden.ouder.email": "E-mail",
  "leden.ouder.soort": "Relatie",
  "leden.ouder.soort.ouder": "ouder",
  "leden.ouder.soort.voogd": "voogd",
  "leden.ouder.soort.verzorger": "verzorger",
  "leden.ouder.tot": "tot {datum}",
  "leden.ouder.beeindigd": "beëindigd op {datum}",
  "leden.ouder.stop": "Beëindigen",
  "leden.toestemming.uitleg": "Per doel. Een wijziging wordt als nieuwe regel vastgelegd, met datum en wie hem vastlegde. Intrekken werkt vooruit, niet terug.",
  "leden.toestemming.beeldmateriaal": "Foto en video",
  "leden.toestemming.mailing_extern": "Mailings buiten de club om",
  "leden.toestemming.publicatie_uitslagen": "Naam in openbare uitslagen",
  "leden.toestemming.nietgevraagd": "nog niet gevraagd",
  "leden.toestemming.bron": "Hoe is de toestemming gegeven?",
  "leden.toestemming.bron.formulier": "Schriftelijk formulier",
  "leden.toestemming.bron.mondeling": "Mondeling",
  "leden.paspoort.uitleg": "Alleen zichtbaar voor wie paspoortgegevens mag beheren. Het nummer komt niet in het auditlog.",
  "leden.paspoort.nummer": "Paspoortnummer",
  "leden.paspoort.land": "Land van uitgifte",
  "leden.paspoort.vervalt": "Geldig tot",
  "leden.naopslaan": "Na het opslaan kun je ouders, toestemmingen en paspoortgegevens toevoegen.",
  "leden.nieuw": "Nieuw lid",
  "leden.achternaamverplicht": "Vul minstens een achternaam in.",
  "leden.opgeslagen": "Opgeslagen",
  "leden.weg.titel": "Lid verwijderen",
  "leden.weg.uitleg": "{naam} verdwijnt uit de ledenadministratie van deze organisatie, met lidmaatschap, ouders en toestemmingen. Gegevens bij andere organisaties en de bond blijven staan.",
  "leden.weg.klaar": "Lid verwijderd",
  "leden.dubbelen.titel": "Mogelijke dubbelen",
  "leden.dubbelen.uitleg": "Personen met dezelfde achternaam en geboortedatum, of hetzelfde e-mailadres en dezelfde voornaam. Controleer ze zelf: het kan ook een tweeling of een gezin zijn.",
  "leden.dubbelen.reden.naam": "zelfde achternaam en geboortedatum",
  "leden.dubbelen.reden.email": "zelfde e-mailadres en voornaam",
  "import.titel": "Ledenlijst importeren",
  "import.uitleg": "Kies een Excel-bestand (.xlsx) of CSV. De eerste rij moet de kolomnamen bevatten. Je ziet eerst wat er gebeurt; er wordt niets opgeslagen voordat je bevestigt.",
  "import.tip.perpersoon": "Eén regel per persoon. Een regel met een heel gezin kan niet worden verwerkt.",
  "import.tip.paspoort": "Paspoortnummers worden nooit geïmporteerd, ook niet als ze in de lijst staan.",
  "import.tip.dubbel": "Wie al in de ledenadministratie staat of twee keer in het bestand, wordt overgeslagen.",
  "import.leeg": "Het bestand heeft geen regels onder de kolomnamen.",
  "import.onleesbaar": "Dit bestand kon niet worden gelezen: {melding}",
  "import.koppelen.titel": "Kolommen koppelen: {bestand}",
  "import.koppelen.uitleg": "{aantal} regels gevonden. Controleer per kolom waar hij terechtkomt. Wat je niet nodig hebt, zet je op Niet gebruiken.",
  "import.kol.kolom": "Kolom in het bestand",
  "import.kol.voorbeeld": "Voorbeeld",
  "import.kol.veld": "Wordt",
  "import.kol.rij": "Regel",
  "import.kol.naam": "Naam",
  "import.kol.opmerking": "Opmerking",
  "import.nietimporteren": "Wordt niet geïmporteerd",
  "import.geweigerd.paspoort": "Paspoortgegevens horen niet in een ledenlijst en worden apart vastgelegd.",
  "import.geweigerd.gezin": "Meerdere personen in één cel zijn niet betrouwbaar te splitsen.",
  "import.controleren": "Controleren",
  "import.controle.titel": "Controle vóór het importeren",
  "import.controle.nieuw": "{aantal} nieuw",
  "import.controle.overslaan": "{aantal} overgeslagen",
  "import.controle.fout": "{aantal} met fouten",
  "import.controle.geweigerd": "Deze kolommen worden niet geïmporteerd: {kolommen}",
  "import.controle.schoon": "Geen opmerkingen. Alles kan worden geïmporteerd.",
  "import.start": "{aantal} leden importeren",
  "import.bezig": "Bezig met importeren",
  "import.voortgang": "{klaar} van {totaal} verwerkt",
  "import.klaar.titel": "Import klaar",
  "import.klaar.uitleg": "{aantal} leden toegevoegd, elk met een actief lidmaatschap.",
  "import.klaar.mislukt": "{aantal} regels konden niet worden opgeslagen.",
  "import.klaar.daarna": "Controleer daarna de werklijst met mogelijke dubbelen en vraag toestemmingen apart na: die zijn uit een ledenlijst niet betrouwbaar af te leiden.",
  "import.doel.negeren": "Niet gebruiken",
  "import.doel.volledige_naam": "Volledige naam (wordt gesplitst)",
  "import.doel.voornaam": "Voornaam",
  "import.doel.tussenvoegsel": "Tussenvoegsel",
  "import.doel.achternaam": "Achternaam",
  "import.doel.geboortedatum": "Geboortedatum",
  "import.doel.geslacht": "Geslacht",
  "import.doel.email": "E-mail",
  "import.doel.telefoon": "Telefoon",
  "import.doel.adres": "Volledig adres (wordt gesplitst)",
  "import.doel.straat": "Straat",
  "import.doel.huisnummer": "Huisnummer",
  "import.doel.postcode": "Postcode",
  "import.doel.plaats": "Plaats",
  "import.doel.land": "Land",
  "import.doel.nationaliteiten": "Nationaliteit",
  "import.doel.lidnummer": "Lidnummer",
  "import.doel.trainingsgroep": "Trainingsgroep",
  "import.doel.graad_opgave": "Graad",
  "import.doel.notities": "Notities",
  "import.doel.lid_sinds": "Lid sinds",
  "import.doel.ouder_naam": "Naam ouder of verzorger",
  "import.doel.ouder1_email": "E-mail ouder 1",
  "import.doel.ouder2_email": "E-mail ouder 2",
  "import.melding.gezinsregel": "Meerdere personen op één regel. Lever één regel per persoon aan.",
  "import.melding.achternaam_ontbreekt": "Geen achternaam.",
  "import.melding.naam_leeg": "Geen naam.",
  "import.melding.datum_tweecijferig": "Jaartal met twee cijfers ({waarde}); datum niet ingevuld.",
  "import.melding.datum_onleesbaar": "Datum niet te lezen ({waarde}); niet ingevuld.",
  "import.melding.datum_ongeldig": "Datum bestaat niet ({waarde}); niet ingevuld.",
  "import.melding.datum_buiten_bereik": "Datum ligt in de toekomst of vóór 1900 ({waarde}); niet ingevuld.",
  "import.melding.lidsinds_onleesbaar": "Lid sinds niet te lezen ({waarde}); niet ingevuld.",
  "import.melding.geslacht_onbekend": "Geslacht niet herkend ({waarde}); niet ingevuld.",
  "import.melding.nationaliteit_onbekend": "Nationaliteit deels niet herkend ({waarde}).",
  "import.melding.email_ongeldig": "Geen geldig e-mailadres ({waarde}); niet ingevuld.",
  "import.melding.bestaat_al": "Staat al in de ledenadministratie; overgeslagen.",
  "import.melding.dubbel_in_bestand": "Staat al eerder in het bestand (regel {rij}); overgeslagen.",
  "export.titel": "Ledenadministratie exporteren",
  "export.uitleg": "Een volledige kopie van de ledenadministratie van deze organisatie, in een open formaat dat elk ander systeem kan inlezen.",
  "export.inhoud.json": "JSON per tabel: personen, lidmaatschappen en functies, ouders, toestemmingen",
  "export.inhoud.csv": "CSV van de personen, te openen in Excel",
  "export.inhoud.manifest": "manifest.json met schemaversie, datum, maker en aantallen",
  "export.paspoort": "Paspoortgegevens meenemen",
  "export.gelogd": "Elke export komt in het auditlog, met je naam en het aantal personen.",
  "export.start": "Exporteren",
  "export.klaar": "Export gedownload",

  // Zelfbeheer, inloglink en tweestapsverificatie
  "auth.of": "of",
  "auth.link.placeholder": "naam@voorbeeld.nl",
  "auth.link.knop": "Stuur link",
  "auth.link.ongeldig": "Vul een geldig e-mailadres in.",
  "auth.link.verstuurd": "Er is een inloglink gestuurd naar {email}. Open hem op dit apparaat.",
  "claim.titel.zelf": "Je gegevens zelf beheren",
  "claim.titel.ouder": "De gegevens van {naam} beheren",
  "claim.uitleg.zelf": "{organisatie} nodigt je uit om je eigen gegevens te beheren. Daarna pas je zelf je naam, adres en toestemmingen aan, en werkt een wijziging door zonder dat de club iets hoeft te doen.",
  "claim.uitleg.ouder": "{organisatie} nodigt je uit om de gegevens van {naam} te beheren. Dat kan tot de achttiende verjaardag, tenzij {naam} de toegang daarna verlengt.",
  "claim.bevestig": "Bevestigen",
  "claim.anderaccount": "Inloggen met een ander account",
  "claim.anderemail": "Deze uitnodiging is verstuurd naar {email}, maar je bent ingelogd als {ingelogd}. Log in met het adres waarop je de uitnodiging kreeg.",
  "claim.status.gebruikt": "Deze uitnodiging is al gebruikt.",
  "claim.status.ingetrokken": "Deze uitnodiging is ingetrokken door de club.",
  "claim.status.verlopen": "Deze uitnodiging is verlopen. Vraag de club om een nieuwe.",
  "claim.status.onbekend": "Deze uitnodiging bestaat niet. Controleer of je de hele link hebt gebruikt.",
  "claim.fout.geen_recht": "Je hebt hiervoor geen rechten.",
  "claim.fout.al_geclaimd": "Deze gegevens worden al door iemand zelf beheerd.",
  "claim.fout.geen_geboortedatum": "Leg eerst de geboortedatum vast; zelfbeheer kan vanaf 16 jaar.",
  "claim.fout.onder_16": "Zelfbeheer kan vanaf 16 jaar. Tot die tijd beheert een ouder de gegevens.",
  "claim.fout.onbekende_ouder": "Deze ouder hoort niet bij dit lid.",
  "claim.fout.ouder_beeindigd": "De relatie met deze ouder is beëindigd.",
  "claim.fout.geen_email": "Er is geen e-mailadres om de uitnodiging naartoe te sturen.",
  "claim.fout.onbekend": "Deze uitnodiging bestaat niet.",
  "claim.fout.gebruikt": "Deze uitnodiging is al gebruikt.",
  "claim.fout.ingetrokken": "Deze uitnodiging is ingetrokken.",
  "claim.fout.verlopen": "Deze uitnodiging is verlopen.",
  "claim.fout.ander_email": "Log in met het e-mailadres waarop je de uitnodiging kreeg.",
  "claim.fout.te_jong": "Dit kan vanaf 17 jaar.",
  "claim.fout.te_lang": "Verlengen kan tot hooguit vijf jaar vooruit.",
  "mijn.titel": "Mijn gegevens",
  "mijn.knop": "Mijn gegevens",
  "mijn.naarbeheer": "Naar beheer",
  "mijn.uitleg": "Wat je hier aanpast, geldt direct bij de club. Je geboortedatum en je lidmaatschap beheert de club.",
  "mijn.alsouder": "je beheert deze gegevens als ouder",
  "mijn.lidsinds": "Lid sinds {datum}",
  "mijn.sectie.gegevens": "Gegevens",
  "mijn.sectie.ouders": "Ouders met toegang",
  "mijn.sectie.jouwrelatie": "Jouw relatie",
  "mijn.vast": "Geboortedatum {geboortedatum}. Klopt die niet, vraag de club dan om een correctie.",
  "mijn.toestemming.uitleg": "Je beslist zelf. Intrekken werkt vanaf nu, niet voor wat al gepubliceerd is.",
  "mijn.ouder.tot": "toegang tot {datum}",
  "mijn.ouder.nietgeclaimd": "nog niet in gebruik",
  "mijn.ouder.uitleg": "Na je achttiende verjaardag stopt de toegang van je ouders, tenzij je die verlengt.",
  "mijn.ouder.verleng": "Toegang verlengen",
  "mijn.ouder.beeindig": "Toegang beëindigen",
  "mijn.ouder.beeindigvraag": "Deze ouder kan je gegevens daarna niet meer zien of wijzigen. Doorgaan?",
  "mijn.ouder.verlengd": "Toegang verlengd",
  "mijn.ouder.beeindigd": "Toegang beëindigd",
  "tweestap.kop": "Tweestapsverificatie",
  "tweestap.titel": "Tweestapsverificatie",
  "tweestap.uitleg": "Voer de code van zes cijfers uit je authenticator-app in.",
  "tweestap.controleer": "Controleren",
  "tweestap.fout": "Deze code klopt niet. Probeer het opnieuw met de huidige code.",
  "tweestap.aan": "Tweestapsverificatie staat aan voor je account.",
  "tweestap.uit": "Je account heeft nog geen tweede factor. Als owner of admin kun je persoonsgegevens van leden zien en exporteren; stel hem daarom in.",
  "tweestap.instellen": "Instellen",
  "tweestap.scan": "Scan de QR-code met een authenticator-app en voer de code in.",
  "tweestap.handmatig": "Of voer deze sleutel handmatig in:",
  "tweestap.bevestig": "Bevestigen",
  "tweestap.ingesteld": "Tweestapsverificatie ingesteld",
  "tweestap.zonder": "Beheerders zonder tweede factor:",
  "tweestap.melding": "Je account heeft nog geen tweestapsverificatie. Stel die in onder Gebruikers en instellingen, Gebruikersbeheer.",
  "leden.sectie.zelfbeheer": "Zelfbeheer",
  "leden.claim.uitleg": "Een lid vanaf 16 en elke ouder kan de gegevens zelf beheren. Je krijgt een link die je zelf doorstuurt; hij werkt alleen met het e-mailadres waarop hij staat en is 14 dagen geldig.",
  "leden.claim.zelf": "Uitnodigen voor zelfbeheer",
  "leden.claim.ouder": "Uitnodigen",
  "leden.claim.teJong": "Zelfbeheer kan vanaf 16 jaar. Nodig een ouder uit.",
  "leden.claim.open": "uitnodiging geldig tot {datum}",
  "leden.claim.klaar": "Uitnodiging gemaakt voor {email}, geldig tot {datum}. Stuur deze link zelf door; hij wordt maar één keer getoond.",
  "leden.claim.kopieer": "Kopieer",
  "leden.claim.gekopieerd": "Link gekopieerd",
  "leden.aflopend": "{aantal} ouderrelaties lopen binnen 45 dagen af, meestal door een achttiende verjaardag.",
  "nav.goedkeuringen": "Goedkeuringen",
  "titel.goedkeuringen": "Goedkeuringen",
  "vierogen.ingediend": "Voorstel ingediend. Een tweede beheerder moet het goedkeuren.",
  "vierogen.uitgevoerd": "Correctie uitgevoerd",
  "vierogen.teruggedraaid": "Correctie teruggedraaid",
  "vierogen.alleen": "Er is geen tweede bevoegde in deze organisatie, dus de handeling is direct uitgevoerd. Dit staat in het auditlog.",
  "vierogen.wacht": "{handeling} wacht op goedkeuring (voorgesteld door {door})",
  "vierogen.handeling.finance.adjust": "Saldo corrigeren",
  "vierogen.handeling.finance.writeoff": "Saldo afboeken",
  "vierogen.handeling.finance.reverse": "Correctie terugdraaien",
  "vierogen.effect.saldo": "Saldo van {van} naar {naar}",
  "vierogen.effect.afboeken": "Openstaand saldo van {bedrag} wordt afgeboekt",
  "vierogen.effect.terug": "Saldo van {van} terug naar {naar} (gefactureerd {gefactureerd})",
  "vierogen.nietbeschikbaar": "Goedkeuringen zijn nog niet beschikbaar. De database-update van deze versie is waarschijnlijk nog niet uitgevoerd.",
  "vierogen.tebeslissen": "Te beslissen",
  "vierogen.tebeslissen.uitleg": "Voorstellen van andere beheerders. Je kunt niet over je eigen voorstel beslissen.",
  "vierogen.goedkeuren": "Goedkeuren",
  "vierogen.afwijzen": "Afwijzen",
  "vierogen.niets": "Er wacht niets op jouw besluit.",
  "vierogen.eigen": "Mijn voorstellen",
  "vierogen.intrekken": "Intrekken",
  "vierogen.geeneigen": "Je hebt geen open voorstellen.",
  "vierogen.afgerond": "Afgerond",
  "vierogen.geenafgerond": "Nog geen afgeronde voorstellen.",
  "vierogen.status.uitgevoerd": "Uitgevoerd",
  "vierogen.status.afgewezen": "Afgewezen",
  "vierogen.status.verlopen": "Verlopen",
  "vierogen.status.mislukt": "Mislukt",
  "vierogen.status.ingetrokken": "Ingetrokken",
  "vierogen.beleid": "Vierogenprincipe",
  "vierogen.beleid.uitleg": "Staat het aan, dan voert een tweede beheerder de handeling pas uit na goedkeuring. Is er geen tweede bevoegde, dan gaat de handeling direct door met een aantekening in het auditlog.",
  "vierogen.beleid.aan": "Aan",
  "vierogen.door": "Voorgesteld door {door} op {wanneer}",
  "vierogen.vervalt": "vervalt {wanneer}",
  "vierogen.besluit.uitgevoerd": "Goedgekeurd en uitgevoerd",
  "vierogen.besluit.afgewezen": "Afgewezen",
  "vierogen.besluit.verlopen": "Dit voorstel was al verlopen",
  "vierogen.besluit.mislukt": "Goedgekeurd, maar uitvoeren is mislukt. De inschrijving is intussen gewijzigd.",
  "vierogen.besluit.open": "Besluit vastgelegd. Er is nog een goedkeuring nodig.",
  "dispatch.fout.alleen_via_dispatcher": "Deze wijziging kan alleen via de correctieknoppen, zodat vierogen en het auditlog gelden.",
  "dispatch.fout.bond_verplicht": "Voor deze handeling geldt altijd vierogen bij een bond.",
  "dispatch.fout.alleen_platform": "Alleen platformbeheer mag dit wijzigen.",
  "dispatch.fout.onbekend_object": "De inschrijving bestaat niet (meer).",
  "dispatch.fout.ongeldig_bedrag": "Het bedrag is ongeldig.",
  "dispatch.fout.niets_af_te_boeken": "Er staat niets open om af te boeken.",
  "dispatch.fout.niets_terug_te_draaien": "Er is geen correctie om terug te draaien.",
  "dispatch.fout.onbekende_handeling": "Onbekende handeling.",
  "dispatch.fout.geen_recht": "Je hebt hier geen recht op.",
  "dispatch.fout.reden_ontbreekt": "Geef een reden op.",
  "dispatch.fout.ongeldig_besluit": "Ongeldig besluit.",
  "dispatch.fout.onbekend_verzoek": "Dit voorstel bestaat niet.",
  "dispatch.fout.niet_open": "Over dit voorstel is al besloten.",
  "dispatch.fout.eigen_voorstel": "Je kunt niet over je eigen voorstel beslissen.",
  "dispatch.fout.proef_ok": "Proefrun geslaagd.",
  "bond.sectie": "Bondsregister",
  "bond.uitleg": "Graduaties, licenties en schorsingen legt de bond vast. Elke wijziging is een voorstel dat een tweede bevoegde moet goedkeuren.",
  "bond.nietbeschikbaar": "Het bondsregister is nog niet beschikbaar. De database-update van deze versie is waarschijnlijk nog niet uitgevoerd.",
  "bond.graduaties": "Graduaties",
  "bond.graduaties.geen": "Nog geen graduaties vastgelegd.",
  "bond.graad": "Graad",
  "bond.datum": "Datum",
  "bond.examinator": "Examinator of commissie",
  "bond.bron": "uit {bron}",
  "bond.reden": "Reden",
  "bond.reden.voorbeeld": "bijvoorbeeld: examen 14 juni, commissie Noord",
  "bond.voorstellen": "Voorstellen",
  "bond.intrekken": "Intrekken",
  "bond.licenties": "Licenties",
  "bond.licenties.geen": "Geen licenties.",
  "bond.licentie.soort": "Licentie",
  "bond.licentie.geldig": "Geldig",
  "bond.licentie.verlopen": "Verlopen",
  "bond.licentie.ingetrokken": "Ingetrokken",
  "bond.licentie.geensoorten": "Er zijn nog geen licentiesoorten. Leg ze vast onder Registerinstellingen.",
  "bond.maanden": "{aantal} maanden",
  "bond.onbeperkt": "onbeperkt geldig",
  "bond.vanaf": "Vanaf",
  "bond.vandaag": "vandaag",
  "bond.tot.optioneel": "Tot (leeg: standaard geldigheid)",
  "bond.tot.onbepaald": "Tot (leeg: onbepaald)",
  "bond.schorsing": "Schorsing",
  "bond.schorsing.geen": "Niet geschorst.",
  "bond.schorsing.periode": "Geschorst van {van} tot en met {tot}",
  "bond.schorsing.onbepaald": "Geschorst vanaf {van}, voor onbepaalde tijd",
  "bond.schorsing.reden": "Reden: {reden}",
  "bond.schorsing.opheffen": "Schorsing opheffen",
  "bond.schorsing.zichtbaar": "Wie leden mag zien, ziet dat iemand geschorst is. De reden ziet alleen wie mag schorsen.",
  "bond.schorsen": "Schorsen",
  "bond.geschorst": "Geschorst",
  "bond.geschorst.tot": "Geschorst tot {datum}",
  "bond.kol.graad": "Graad",
  "bond.instellingen": "Registerinstellingen",
  "bond.schaal": "Graduatieschaal",
  "bond.schaal.standaard": "Je gebruikt de standaard ITF-schaal. Pas hem aan als je bond een andere schaal of andere namen gebruikt.",
  "bond.schaal.eigen": "De eigen schaal van je bond, van laag naar hoog. De volgorde bepaalt welke graad de hoogste is.",
  "bond.schaal.aanpassen": "Schaal aanpassen",
  "bond.schaal.nieuw": "Nieuwe graad (komt bovenaan)",
  "bond.schaal.leeg": "Elke graad heeft een naam nodig.",
  "bond.omhoog": "Omlaag in de schaal",
  "bond.toevoegen": "Toevoegen",
  "bond.soorten": "Licentiesoorten",
  "bond.soorten.uitleg": "Bij het toekennen krijgt een licentie de standaard geldigheid, tenzij je een einddatum opgeeft.",
  "bond.soorten.geen": "Nog geen licentiesoorten.",
  "bond.soort.naam": "Naam",
  "bond.soort.geldigheid": "Geldigheid in maanden",
  "bond.soort.actief": "In gebruik",
  "vierogen.handeling.grade.set": "Graduatie toekennen",
  "vierogen.handeling.grade.revoke": "Graduatie intrekken",
  "vierogen.handeling.licence.grant": "Licentie toekennen",
  "vierogen.handeling.licence.revoke": "Licentie intrekken",
  "vierogen.handeling.member.suspend": "Lid schorsen",
  "vierogen.handeling.member.unsuspend": "Schorsing opheffen",
  "vierogen.effect.graad": "{graad} per {datum}",
  "vierogen.effect.graad_weg": "{graad} vervalt",
  "vierogen.effect.licentie": "{licentie} vanaf {van}, met de standaard geldigheid",
  "vierogen.effect.licentie_tot": "{licentie} van {van} tot en met {tot}",
  "vierogen.effect.licentie_weg": "{licentie} vervalt per vandaag",
  "vierogen.effect.schorsing": "Geschorst vanaf {van}, voor onbepaalde tijd",
  "vierogen.effect.schorsing_tot": "Geschorst van {van} tot en met {tot}",
  "vierogen.effect.opheffen": "De schorsing eindigt per vandaag",
  "dispatch.fout.alleen_bond": "Dit kan alleen in een organisatie met de module bond.",
  "dispatch.fout.onbekende_graad": "Deze graad staat niet op de graduatieschaal.",
  "dispatch.fout.al_toegekend": "Deze graad of licentie is al toegekend.",
  "dispatch.fout.onbekende_licentie": "Deze licentiesoort bestaat niet of is niet meer in gebruik.",
  "dispatch.fout.ongeldige_datum": "De datum klopt niet: een graduatie ligt niet in de toekomst en een einddatum niet vóór de begindatum.",
  "dispatch.fout.al_geschorst": "Dit lid is in die periode al geschorst.",
  "dispatch.fout.niet_actief": "Dit is al beëindigd of ingetrokken.",
  "start.knop": "Start",
  "start.titel": "Mijn {merk}",
  "start.nietbeschikbaar": "Het startscherm is nog niet volledig beschikbaar. De database-update van deze versie is waarschijnlijk nog niet uitgevoerd.",
  "start.niets": "Er is nog niets voor je ingericht.",
  "start.mijn": "Mijn gegevens",
  "start.mijn.uitleg": "Je eigen gegevens als lid, en die van je kinderen als ouder.",
  "start.openen": "Openen",
  "start.platform": "Platformbeheer",
  "start.alle": "Alle organisaties",
  "start.alle.uitleg": "Modules per organisatie. Gegevens van een organisatie waar je geen lid van bent, zie je pas met platformtoegang: tijdelijk, met reden, en zichtbaar voor de organisatie.",
  "start.kol.organisatie": "Organisatie",
  "start.kol.toegang": "Toegang",
  "start.module.toernooien": "Toernooien",
  "start.module.leden": "Leden",
  "start.module.bond": "Clubregister",
  "start.module.goedkeuringen": "Goedkeuringen",
  "start.module.beheer": "Gebruikers en instellingen",
  "start.stand.actief": "Actief",
  "start.stand.uit": "Uit",
  "start.stand.nvt": "Niet voor dit type",
  "start.stand.geenrecht": "Niet voor jouw rol",
  "start.stand.geentoegang": "Geen toegang",
  "start.stip.aan": "Aan",
  "start.stip.uit": "Uit",
  "start.stip.nvt": "N.v.t.",
  "start.type.club": "Club",
  "start.type.organisator": "Toernooiorganisator",
  "start.type.bond": "Bond",
  "start.rolnaam.owner": "Owner",
  "start.rolnaam.admin": "Admin",
  "start.rolnaam.editor": "Editor",
  "start.rolnaam.viewer": "Viewer",
  "start.toegang.lid": "Lid",
  "start.toegang.tot": "Platformtoegang tot {tijd}",
  "start.toegang.geen": "Geen",
  "start.toegang.aanvragen": "Toegang aanvragen",
  "start.toegang.reden": "Reden",
  "start.toegang.voorbeeld": "bijvoorbeeld: vraag van de secretaris over de import van 12 september",
  "start.toegang.uren": "Uren",
  "start.toegang.kort": "Geef een reden van minstens tien tekens.",
  "start.toegang.platform": "Platformtoegang",
  "start.viaplatform": "Je werkt hier via platformtoegang, niet als lid. De organisatie ziet dat, en elke wijziging staat in het auditlog.",
  "super.titel": "Superbeheer",
  "super.env.production": "PRODUCTIE",
  "super.env.staging": "STAGING",
  "super.env.preview": "PREVIEW",
  "super.env.development": "ONTWIKKEL",
  "super.naar": "Naar",
  "super.start": "Startscherm",
  "super.platform": "Platformbeheer",
  "super.toegang": "toegang",
  "super.geentoegang": "geen toegang",
  "super.bekijkals": "Bekijk als",
  "super.eigenrol": "Eigen rol",
  "super.simulatie": "Je ziet de app als {rol}. De database geeft je nog je eigen rechten.",
  "super.inzicht": "Inzicht",
  "super.aanvraag": "Je bent geen lid van {naam}. Vraag platformtoegang aan om de gegevens te zien.",
  "super.uur": "uur",
  "super.i.email": "Ingelogd als",
  "super.i.omgeving": "Omgeving",
  "super.i.organisatie": "Organisatie",
  "super.i.echterol": "Echte rol",
  "super.i.viatoegang": "Platformtoegang",
  "super.i.bekeken": "Weergave als",
  "super.i.toegang": "Toegang tot",
  "super.i.modules": "Modules",
  "super.i.onbekend": "onbekend (alles zichtbaar)",
  "super.i.rechten": "Rechten in beeld",
  "super.i.uitleg": "Dit is wat de app laat zien. Wat je werkelijk mag, bepaalt de database per handeling.",
  "nav.module": "Module",
  "nav.sectie.toernooi": "Toernooi",
  "start.naarstart": "Naar het startscherm",
  "nav.toernooiinstellingen": "Toernooi-instellingen",
  "titel.toernooiinstellingen": "Toernooi-instellingen",
  "eigendom.nieuw": "Nieuwe organisatie",
  "eigendom.nieuw.uitleg": "Een club, bond of losse toernooiorganisator die Tornema gaat gebruiken. Platformbeheer keurt de aanvraag goed; daarna aanvaard je de voorwaarden en ben je owner. Een nieuw toernooi binnen je eigen organisatie maak je aan in de module Toernooien, onder Toernooi-instellingen.",
  "eigendom.nieuw.knop": "Nieuwe organisatie aanvragen",
  "eigendom.aanvraag.naam": "Naam van de organisatie",
  "eigendom.aanvraag.naam.voorbeeld": "bijvoorbeeld: Stichting Noord Open of TKD Zuid",
  "eigendom.aanvraag.datum": "Datum editie",
  "eigendom.aanvraag.land": "Land",
  "eigendom.aanvraag.toelichting": "Toelichting",
  "eigendom.aanvraag.toelichting.voorbeeld": "Wat voor organisatie, en bij een toernooi: waar, en hoeveel deelnemers je verwacht",
  "eigendom.aanvraag.versturen": "Aanvraag versturen",
  "eigendom.aanvraag.verstuurd": "Aanvraag verstuurd. Je ziet hier wanneer hij is goedgekeurd.",
  "eigendom.status.open": "wacht op goedkeuring",
  "eigendom.status.goedgekeurd": "goedgekeurd",
  "eigendom.status.afgewezen": "afgewezen",
  "eigendom.status.ingetrokken": "ingetrokken",
  "eigendom.intrekken": "Intrekken",
  "eigendom.beoordelen": "Aanvragen voor een nieuwe organisatie",
  "eigendom.beoordelen.reden": "Toelichting of reden",
  "eigendom.goedgekeurd": "Goedgekeurd. De aanvrager ziet nu het aanbod om owner te worden.",
  "eigendom.afgewezen": "Afgewezen",
  "eigendom.aanbod.nieuw": "Je aanvraag voor {naam} is goedgekeurd",
  "eigendom.aanbod.nieuw.uitleg": "Aanvaard de voorwaarden om owner te worden. Daarna richt je de organisatie in en nodig je beheerders uit.",
  "eigendom.aanbod.overdracht": "Je bent uitgenodigd als owner van {naam}",
  "eigendom.aanbod.overdracht.uitleg": "{van} draagt het eigenaarschap aan je over. Reden: {reden}",
  "eigendom.bekijken": "Bekijken en aanvaarden",
  "eigendom.aanvaard.uitleg": "Als owner ga je de overeenkomst met het platform aan namens je organisatie. Lees de documenten en vink ze aan.",
  "eigendom.doc.platform_terms": "Overeenkomst met het platform",
  "eigendom.doc.dpa": "Verwerkersovereenkomst",
  "eigendom.doc.user_terms": "Gebruiksvoorwaarden",
  "eigendom.doc.privacy_policy": "Privacyverklaring",
  "eigendom.lezen": "lezen",
  "eigendom.naam": "Je naam",
  "eigendom.functie": "Functie",
  "eigendom.functie.voorbeeld": "bijvoorbeeld: voorzitter",
  "eigendom.bevoegd": "Ik ben bevoegd om namens deze organisatie te handelen.",
  "eigendom.aanvaarden": "Aanvaarden en owner worden",
  "eigendom.welkom": "Je bent nu owner van {naam}",
  "eigendom.verlopen": "Dit aanbod is verlopen. Vraag de afzender om een nieuw aanbod.",
  "eigendom.overdragen": "Eigenaarschap overdragen",
  "eigendom.overdragen.uitleg": "De ontvanger aanvaardt de voorwaarden en wordt owner. Pas daarna verandert jouw rol. Het aanbod is 14 dagen geldig.",
  "eigendom.overdragen.aan": "E-mailadres van de nieuwe owner",
  "eigendom.overdragen.daarna": "Daarna ben ik",
  "eigendom.blijf.admin": "admin in deze organisatie",
  "eigendom.blijf.weg": "geen lid meer van deze organisatie",
  "eigendom.overdragen.voorbeeld": "bijvoorbeeld: de bond neemt de organisatie over",
  "eigendom.overdragen.knop": "Aanbod versturen",
  "eigendom.overdragen.verstuurd": "Aanbod verstuurd. De ontvanger ziet het na het inloggen op het startscherm.",
  "eigendom.overdragen.open": "Aanbod aan {naar}, geldig tot {datum}.",
  "eigendom.fout.aan_jezelf": "Je kunt het eigenaarschap niet aan jezelf overdragen.",
  "eigendom.fout.al_owner": "Deze persoon is al owner.",
  "eigendom.fout.bevoegdheid": "Bevestig dat je bevoegd bent.",
  "eigendom.fout.geen_recht": "Je hebt hier geen recht op.",
  "eigendom.fout.geen_voorwaarden": "Er zijn nog geen voorwaarden voor owners gepubliceerd. Neem contact op met platformbeheer.",
  "eigendom.fout.naam_functie": "Vul je naam en functie in.",
  "eigendom.fout.naam_ontbreekt": "Geef een naam op.",
  "eigendom.fout.niet_open": "Dit is al afgehandeld.",
  "eigendom.fout.ongeldig_besluit": "Ongeldige keuze.",
  "eigendom.fout.ongeldig_email": "Dit e-mailadres is niet geldig.",
  "eigendom.fout.reden_ontbreekt": "Geef een reden op.",
  "eigendom.fout.te_veel_aanvragen": "Je hebt al drie open aanvragen. Wacht op een besluit of trek er een in.",
  "eigendom.fout.voorwaarden_gewijzigd": "Vink alle documenten aan. Zijn ze net gewijzigd, herlaad dan de pagina.",
  "nav.activiteiten": "Activiteiten",
  "titel.activiteiten": "Activiteiten",
  "start.module.activiteiten": "Activiteiten",
  "act.uitleg": "Examens, cursussen en clinics. Toernooien beheer je in de module Toernooien.",
  "act.nietbeschikbaar": "Activiteiten zijn nog niet beschikbaar. Draai eerst de migratie voor stap J.",
  "act.nieuw": "Nieuwe activiteit",
  "act.wijzigen": "Activiteit wijzigen",
  "act.opslaan": "Opslaan",
  "act.opgeslagen": "Activiteit opgeslagen.",
  "act.verwijderen": "Verwijderen",
  "act.verwijderen.bevestig": "Deze activiteit verwijderen? Dat kan alleen zolang er niemand is ingeschreven.",
  "act.verwijderd": "Activiteit verwijderd.",
  "act.terug": "Alle activiteiten",
  "act.zoek": "Zoek activiteit",
  "act.zoek.deelnemer": "Zoek deelnemer",
  "act.zoek.lid": "Zoek op naam of lidnummer",
  "act.leeg": "Nog geen activiteiten.",
  "act.deelnemers.leeg": "Nog niemand ingeschreven.",
  "act.kandidaten.leeg": "Er zijn geen leden meer om in te schrijven.",
  "act.teams": "teams",
  "act.geen": "Geen",
  "act.toernooi.badge": "via Toernooien",
  "act.toernooi.uitleg": "Inschrijvingen voor een toernooi beheer je in de module Toernooien.",
  "act.kol.naam": "Activiteit",
  "act.kol.soort": "Soort",
  "act.kol.datum": "Datum",
  "act.kol.status": "Status",
  "act.kol.deelnemers": "Deelnemers",
  "act.kol.tarief": "Tarief",
  "act.kol.openstaand": "Openstaand",
  "act.kol.deelnemer": "Deelnemer",
  "act.kol.betaling": "Betaling",
  "act.kol.uitslag": "Uitslag",
  "act.soort.toernooi": "Toernooi",
  "act.soort.examen": "Examen",
  "act.soort.cursus": "Cursus",
  "act.soort.clinic": "Clinic",
  "act.status.concept": "Concept",
  "act.status.open": "Inschrijving open",
  "act.status.gesloten": "Inschrijving gesloten",
  "act.status.afgerond": "Afgerond",
  "act.status.geannuleerd": "Geannuleerd",
  "act.status.gewijzigd": "Status gewijzigd: {status}.",
  "act.naar.open": "Inschrijving openen",
  "act.naar.gesloten": "Inschrijving sluiten",
  "act.naar.afgerond": "Afronden",
  "act.naar.geannuleerd": "Annuleren",
  "act.annuleren.bevestig": "{naam} annuleren? Inschrijvingen en betalingen blijven staan; terugbetalen regel je apart.",
  "act.veld.soort": "Soort",
  "act.veld.status": "Status",
  "act.veld.naam": "Naam",
  "act.veld.naam.voorbeeld": "bijvoorbeeld: Danexamen najaar 2026",
  "act.veld.locatie": "Locatie",
  "act.veld.tarief": "Tarief (euro)",
  "act.veld.start": "Begindatum",
  "act.veld.eind": "Einddatum",
  "act.veld.inschrijventot": "Inschrijven tot en met",
  "act.veld.max": "Maximaal aantal deelnemers",
  "act.veld.minleeftijd": "Minimale leeftijd",
  "act.veld.maxleeftijd": "Maximale leeftijd",
  "act.veld.mingraad": "Minimale graad",
  "act.veld.licentie": "Vereiste licentie",
  "act.veld.uitkomst": "Licentie bij slagen",
  "act.veld.omschrijving": "Omschrijving",
  "act.eisen": "Toelating",
  "act.eisen.uitleg": "De database controleert dit bij elke inschrijving. Leeftijd telt op de begindatum.",
  "act.eisen.geenbond": "Eisen op graad of licentie kan alleen een organisatie met het bondsregister stellen.",
  "act.uitkomst.geen": "Geen licentie (alleen deelname)",
  "act.uitkomst.uitleg": "Geslaagd wordt een voorstel om deze licentie toe te kennen, met vierogen.",
  "act.eis.leeftijd.tussen": "Leeftijd {van} tot en met {tot} jaar",
  "act.eis.leeftijd.vanaf": "Vanaf {van} jaar",
  "act.eis.leeftijd.tot": "Tot en met {tot} jaar",
  "act.eis.graad": "Vanaf {graad}",
  "act.eis.licentie": "Licentie {licentie} vereist",
  "act.eis.tot": "Inschrijven tot {datum}",
  "act.fout.naam": "Geef de activiteit een naam.",
  "act.kpi.deelnemers": "Deelnemers",
  "act.kpi.tarief": "Tarief",
  "act.kpi.ontvangen": "Ontvangen",
  "act.kpi.openstaand": "Openstaand",
  "act.kpi.uitslagen": "Uitslagen",
  "act.inschrijven": "Leden inschrijven",
  "act.inschrijven.uitleg": "Kies leden uit het ledenbestand. Wie niet aan de eisen voldoet of geschorst is, wordt niet ingeschreven; je ziet per persoon waarom.",
  "act.inschrijven.knop": "Inschrijven",
  "act.inschrijven.niemand": "Kies eerst een of meer leden.",
  "act.inschrijven.gelukt": "{aantal} ingeschreven.",
  "act.inschrijven.deels": "{gelukt} ingeschreven, {mislukt} niet. Zie hieronder waarom.",
  "act.inschrijven.dicht": "Inschrijven kan alleen als de inschrijving open staat.",
  "act.selecteer.zichtbaar": "Selecteer zichtbare",
  "act.afgemeld": "Afgemeld",
  "act.afmelden": "Afmelden",
  "act.afmelden.bevestig": "{naam} afmelden? De betaling blijft staan.",
  "act.afgemeld.gedaan": "Afgemeld.",
  "act.betaling": "Betaling",
  "act.betaald": "Betaald",
  "act.korting": "Korting",
  "act.betaling.opslaan": "Betaling opslaan",
  "act.betaling.opgeslagen": "Betaling opgeslagen.",
  "act.betaal.paid": "Betaald",
  "act.betaal.partial": "Deels betaald",
  "act.betaal.unpaid": "Niet betaald",
  "act.betaal.nvt": "Niets te betalen",
  "act.betaal.afgeboekt": "Afgeboekt",
  "act.correctie": "Correctie {bedrag}: {reden}",
  "act.afboeken": "Afboeken",
  "act.terugdraaien": "Correctie terugdraaien",
  "act.nieuwegraad": "Nieuwe graad",
  "act.uitslag.geslaagd": "Geslaagd",
  "act.uitslag.niet_geslaagd": "Niet geslaagd",
  "act.uitslag.geen": "Nog geen uitslag.",
  "act.uitslag.wacht": "Het voorstel wacht op een tweede bevoegde. Pas daarna staat het in het register.",
  "act.uitslag.vastleggen": "Uitslag vastleggen",
  "act.uitslag.uitleg.bond": "Geslaagd wordt een voorstel voor het register. Een tweede bevoegde met het recht om graden of licenties toe te kennen keurt het goed.",
  "act.uitslag.uitleg.club": "De uitslag wordt bij de inschrijving bewaard. Het officiële register houdt de bond bij.",
  "act.uitslagstatus.voorgesteld": "wacht op goedkeuring",
  "act.uitslagstatus.vastgelegd": "vastgelegd",
  "act.uitslagstatus.afgewezen": "afgewezen",
  "act.uitslagstatus.geen_register": "niet in het register",
  "act.uitslagstatus.gedaan.voorgesteld": "Uitslag vastgelegd; het voorstel wacht op goedkeuring.",
  "act.uitslagstatus.gedaan.vastgelegd": "Uitslag vastgelegd.",
  "act.uitslagstatus.gedaan.geen_register": "Uitslag vastgelegd bij de inschrijving.",
  "act.uitslagen": "Uitslagen invoeren",
  "act.uitslagen.leeg": "Er zijn geen deelnemers zonder vastgelegde uitslag.",
  "act.uitslagen.niets": "Kies bij minstens een deelnemer een uitslag.",
  "act.uitslagen.gelukt": "{aantal} uitslagen vastgelegd.",
  "act.uitslagen.deels": "{gelukt} vastgelegd, {mislukt} niet. Zie hieronder waarom.",
  "inschrijving.fout.al_ingeschreven": "Al ingeschreven.",
  "inschrijving.fout.geboortedatum_onbekend": "Geboortedatum onbekend; nodig voor de leeftijdseis.",
  "inschrijving.fout.geen_recht": "Je mag hier niet inschrijven.",
  "inschrijving.fout.geschorst": "Geschorst in de periode van de activiteit.",
  "inschrijving.fout.graad_te_laag": "Graad lager dan de minimale graad.",
  "inschrijving.fout.licentie_ontbreekt": "Geen geldige vereiste licentie.",
  "inschrijving.fout.niet_open": "De inschrijving staat niet open.",
  "inschrijving.fout.onbekende_activiteit": "Deze activiteit bestaat niet (meer).",
  "inschrijving.fout.onbekende_persoon": "Geen lid van deze organisatie.",
  "inschrijving.fout.ongeldig_bedrag": "Een bedrag kan niet negatief zijn.",
  "inschrijving.fout.status": "Een afgemelde inschrijving kan niet terug. Schrijf opnieuw in.",
  "inschrijving.fout.te_jong": "Jonger dan de minimale leeftijd.",
  "inschrijving.fout.te_oud": "Ouder dan de maximale leeftijd.",
  "inschrijving.fout.te_veel": "Hooguit 500 personen per keer.",
  "inschrijving.fout.termijn_voorbij": "De inschrijftermijn is voorbij.",
  "inschrijving.fout.toernooi_via_teams": "Inschrijven voor een toernooi gaat via de module Toernooien.",
  "inschrijving.fout.vast": "Deze gegevens van een inschrijving liggen vast.",
  "inschrijving.fout.vol": "Het maximale aantal deelnemers is bereikt.",
  "uitslag.fout.al_vastgelegd": "Deze graad of licentie staat al in het register. Intrekken gaat via het ledendetail.",
  "uitslag.fout.geen_recht": "Je mag geen uitslagen vastleggen.",
  "uitslag.fout.geen_uitkomst": "Deze soort activiteit heeft geen uitslag.",
  "uitslag.fout.graad_ontbreekt": "Kies de nieuwe graad.",
  "uitslag.fout.niet_mogelijk": "Een uitslag kan alleen bij een ingeschreven deelnemer van een lopende of afgeronde activiteit.",
  "uitslag.fout.nog_niet": "De activiteit is nog niet begonnen.",
  "uitslag.fout.onbekend": "Deze inschrijving bestaat niet (meer).",
  "uitslag.fout.onbekende_graad": "Deze graad staat niet op de graduatieschaal.",
  "uitslag.fout.ongeldig": "Kies geslaagd of niet geslaagd.",
  "uitslag.fout.voorstel_loopt": "Er loopt al een voorstel. Wacht op het besluit.",
  "activiteit.fout.eis_alleen_bond": "Eisen op graad of licentie kan alleen een organisatie met het bondsregister stellen.",
  "activiteit.fout.onbekende_graad": "Deze graad staat niet op de graduatieschaal.",
  "activiteit.fout.onbekende_licentie": "Deze licentiesoort hoort niet bij deze organisatie.",
  "activiteit.fout.toernooi_via_events": "Een toernooi maak je aan in de module Toernooien.",
  "activiteit.fout.vast": "Soort en organisatie van een activiteit liggen vast.",
  "reden.uitleg": "De reden staat in het auditlog en in de wachtrij. Staat vierogen aan, dan gebeurt er pas iets als een tweede bevoegde goedkeurt.",
  "beheer.verwijderen": "Gebruiker verwijderen",
  "beheer.verwijderen.uitleg": "{email} verliest de toegang tot deze organisatie zodra dit is uitgevoerd.",
  "beheer.rol.titel": "Rol wijzigen",
  "beheer.rol.uitleg": "Rol van {email} wijzigen van {van} naar {naar}.",
  "beheer.primair": "De primaire beheerder kan niet worden gewijzigd of verwijderd.",
  "beheer.geentweestap": "geen tweestap",
  "beheer.geentweestap.uitleg": "Deze beheerder heeft nog geen tweede factor ingesteld.",
  "leden.weg.uitleg2": "Wat moet er met {naam} gebeuren?",
  "leden.weg.knop": "Voorstellen",
  "leden.weg.anonimiseren": "Anonimiseren",
  "leden.weg.anonimiseren.uitleg": "Naam, adres, contact en geboortedatum worden gewist. Graden, licenties, inschrijvingen en betalingen blijven, maar zijn niet meer tot deze persoon te herleiden.",
  "leden.weg.verwijderen": "Volledig verwijderen",
  "leden.weg.verwijderen.uitleg": "Alleen voor een tikfout of dubbele invoer. Kan niet als er een graad, licentie, schorsing of inschrijving is.",
  "export.aanvraag.uitleg": "Een export bevat persoonsgegevens. Hij wordt gelogd; staat vierogen aan, dan keurt een tweede bevoegde hem eerst goed. Daarna staat hij 24 uur klaar, voor één download.",
  "export.aanvragen": "Export aanvragen",
  "export.wacht": "Exportaanvraag ingediend. Na goedkeuring staat hij hier 24 uur klaar.",
  "export.klaarstaand": "Klaar om te downloaden:",
  "export.geldig": "geldig tot {wanneer}",
  "export.ophalen": "Downloaden",
  "export.gelogd2": "Elke export komt in het auditlog, met je reden. Bij een bond keurt een tweede bevoegde hem eerst goed.",
  "export.soort.leden": "Ledenexport",
  "export.soort.volledig": "Volledige export",
  "export.volledig.titel": "Volledige export",
  "export.volledig.uitleg": "Alle gegevens van deze organisatie in een open formaat: leden, activiteiten, toernooien, financiën, voorstellen, auditlog en instellingen. JSON per tabel, CSV van de leden en een manifest. Zonder wachtwoorden, tokens of sleutels.",
  "export.fout.onbekend": "Deze export bestaat niet of is niet van jou.",
  "export.fout.al_opgehaald": "Deze export is al gedownload. Vraag een nieuwe aan.",
  "export.fout.verlopen": "Deze export is verlopen. Vraag een nieuwe aan.",
  "export.fout.geen_recht": "Je hebt niet meer het recht om deze export op te halen.",
  "vierogen.handeling.user.role": "Rol wijzigen",
  "vierogen.handeling.user.remove": "Gebruiker verwijderen",
  "vierogen.handeling.person.remove": "Lid verwijderen of anonimiseren",
  "vierogen.handeling.person.export": "Ledenexport",
  "vierogen.handeling.data.export": "Volledige export",
  "vierogen.effect.rol": "Wordt {rol}.",
  "vierogen.effect.gebruiker_weg": "Verliest de toegang tot deze organisatie.",
  "vierogen.effect.lid_weg": "Wordt volledig verwijderd.",
  "vierogen.effect.lid_anoniem": "Wordt geanonimiseerd; sportieve en financiële gegevens blijven.",
  "vierogen.effect.ledenexport": "Ledenexport, zonder paspoortgegevens.",
  "vierogen.effect.ledenexport_paspoort": "Ledenexport, met paspoortgegevens.",
  "vierogen.effect.volledige_export": "Alle gegevens van de organisatie.",
  "dispatch.fout.eigen_account": "Je eigen account wijzig of verwijder je niet zelf. Vraag een andere beheerder.",
  "dispatch.fout.ongeldige_rol": "Onbekende rol.",
  "dispatch.fout.geen_wijziging": "Deze gebruiker heeft die rol al.",
  "dispatch.fout.alleen_owner": "Over een owner beslist alleen een owner, bij het voorstellen en bij het goedkeuren.",
  "dispatch.fout.laatste_owner": "Dit is de laatste owner. Draag het eigenaarschap eerst over.",
  "dispatch.fout.ongeldige_wijze": "Kies verwijderen of anonimiseren.",
  "dispatch.fout.heeft_historie": "Dit lid heeft een graad, licentie, schorsing of inschrijving. Kies anonimiseren.",
  "tweestap.overzicht.titel": "Tweestapsverificatie van beheerders",
  "tweestap.overzicht.uitleg": "Owners, admins en platformbeheerders zonder tweede factor. Pas als deze lijst leeg is, kan de eis in de database aan.",
  "tweestap.overzicht.stand": "{met} van {totaal} beheerders hebben een tweede factor.",
  "tweestap.overzicht.platform": "platformbeheer",
  "tweestap.overzicht.klaar": "Alle beheerders hebben een tweede factor.",
  "tweestap.overzicht.nietbeschikbaar": "Niet beschikbaar. Draai eerst de migratie voor de beveiligingsstap.",
  "reden.voorbeeld.lid": "bijvoorbeeld: dubbel ingevoerd, of verzoek van het lid",
  "reden.voorbeeld.export": "bijvoorbeeld: overstap naar een ander pakket",
  "reden.voorbeeld.gebruiker": "bijvoorbeeld: stopt als penningmeester",
  "start.toernooien": "Toernooien: {lijst}",
  "eigendom.aanvraag.soort": "Soort organisatie",
  "eigendom.soort.club": "Club",
  "eigendom.soort.organisator": "Losse toernooiorganisator",
  "eigendom.soort.bond": "Bond",
  "eigendom.aanvraag.toernooi": "Toernooi (optioneel)",
  "eigendom.aanvraag.toernooi.voorbeeld": "bijvoorbeeld: Noord Open",
  "eigendom.aanvraag.metToernooi": "toernooi {toernooi}",
  "eigendom.fout.ongeldig_type": "Kies de soort organisatie.",
  "toernooi.kaart.titel": "Toernooien",
  "toernooi.kaart.uitleg": "De toernooien van {organisatie}. Elk toernooi heeft edities, bijvoorbeeld per jaar. Leden, gebruikers en betalingen horen bij de organisatie, niet bij een toernooi.",
  "toernooi.edities": "{aantal} edities",
  "toernooi.geen": "Nog geen toernooien.",
  "toernooi.nieuw": "Nieuw toernooi",
  "toernooi.aanmaken": "Toernooi aanmaken",
  "toernooi.aangemaakt": "Toernooi aangemaakt.",
  "toernooi.veld.toernooi": "Toernooi",
  "toernooi.veld.naam": "Naam van het toernooi",
  "toernooi.veld.naam.voorbeeld": "bijvoorbeeld: EK 2027 of Noord Open",
  "toernooi.veld.editie": "Naam editie",
  "toernooi.veld.editie.voorbeeld": "bijvoorbeeld: Noord Open 2027",
  "toernooi.veld.datum": "Datum editie",
  "toernooi.veld.uitleg": "Editie en datum zijn optioneel. Een bestaand toernooi dat overstapt, begin je met de editie die als eerste in Tornema komt.",
  "toernooi.fout.naam_ontbreekt": "Geef het toernooi een naam.",
  "toernooi.fout.bestaat_al": "Deze organisatie heeft al een toernooi met die naam.",
  "toernooi.fout.andere_organisatie": "Dit toernooi hoort bij een andere organisatie.",
  "toernooi.fout.verhuizen_niet_hier": "Een toernooi naar een andere organisatie verhuizen kan hier niet.",
  "organisatie.titel": "Organisatie",
  "organisatie.uitleg": "De club, bond of organisator die Tornema gebruikt. Deze naam staat in de zijbalk, op het startscherm en in e-mails. Toernooien vallen hieronder.",
  "organisatie.naam": "Naam van de organisatie",
  "organisatie.type": "Soort: {typen}. Wijzigen gaat via platformbeheer.",
  "organisatie.opgeslagen": "Naam opgeslagen.",
  "nav.toernooien": "Alle toernooien",
  "nav.sectie.editie": "Editie",
  "titel.toernooien": "Toernooien",
  "toernooi.kol.naam": "Toernooi",
  "toernooi.kol.edities": "Edities",
  "toernooi.kol.laatste": "Laatste editie",
  "toernooi.kol.teams": "Teams",
  "toernooi.kol.editie": "Editie",
  "toernooi.kol.datum": "Datum",
  "toernooi.kol.locatie": "Locatie",
  "toernooi.zoek": "Zoek toernooi",
  "toernooi.zoek.editie": "Zoek editie",
  "toernooi.terug": "Alle toernooien",
  "toernooi.nieuweEditie": "Nieuwe editie",
  "toernooi.edities.leeg": "Nog geen edities. Voeg er een toe met Nieuwe editie.",
  "ref.kol": "Code",
  "ref.kopieer": "Klik om de code te kopiëren",
  "ref.gekopieerd": "{code} gekopieerd.",
  "mijn.act.titel": "Activiteiten voor {naam}",
  "mijn.act.inschrijven": "Inschrijven",
  "mijn.act.aanvragen": "Aanvragen",
  "mijn.act.intrekken": "Aanvraag intrekken",
  "mijn.act.afmeldenviaclub": "Afmelden via de club",
  "mijn.act.status.aangevraagd": "Aangevraagd",
  "mijn.act.status.ingeschreven": "Ingeschreven",
  "mijn.act.status.afgewezen": "Afgewezen",
  "mijn.act.status.afgemeld": "Afgemeld",
  "mijn.act.bedrag": "Tarief {tarief}, nog te betalen {open}.",
  "mijn.act.tarief": "Tarief {tarief}, te betalen aan de club.",
  "mijn.act.wachtopclub": "Wacht op akkoord van de club",
  "mijn.act.reden": "Reden: {reden}",
  "mijn.act.akkoorduitleg": "De club beoordeelt je aanvraag",
  "mijn.act.vraag.inschrijving": "{naam} inschrijven voor {activiteit}?",
  "mijn.act.vraag.aanvraag": "Aanvraag indienen voor {naam} voor {activiteit}? De club beslist.",
  "mijn.act.vraag.kosten": "Kosten {tarief}, te betalen aan de club.",
  "mijn.act.vraag.afmelden": "Afmelden voor {activiteit}?",
  "mijn.act.ingeschreven": "Ingeschreven.",
  "mijn.act.aangevraagd": "Aanvraag ingediend. De club laat weten of het doorgaat.",
  "act.zelf": "Inschrijven door leden",
  "act.veld.zelf": "Leden en ouders kunnen zelf inschrijven",
  "act.veld.akkoord": "Eerst akkoord van de club nodig",
  "act.zelf.uitleg": "Een lid met een eigen account schrijft zichzelf in, een ouder een kind tot 18. Met akkoord wordt het eerst een aanvraag die je hier goedkeurt of afwijst.",
  "act.zelf.aan": "Open voor zelf inschrijven",
  "act.zelf.aan.akkoord": "Open voor aanvragen door leden",
  "act.aanvragen.aantal": "Aanvragen: {aantal}",
  "act.aanvragen.banner": "Open aanvragen: {aantal}. Klik op een deelnemer om te beslissen.",
  "act.aangevraagd": "Aanvraag",
  "act.afgewezen": "Afgewezen",
  "act.kol.bron": "Via",
  "act.bron.beheerder": "Club",
  "act.bron.zelf": "Lid zelf",
  "act.bron.ouder": "Ouder",
  "act.aanvraag": "Aanvraag",
  "act.aanvraag.uitleg": "Aangevraagd op {datum} door {door}.",
  "act.aanvraag.reden": "Toelichting voor het lid (optioneel)",
  "act.aanvraag.akkoord": "Akkoord",
  "act.aanvraag.afwijzen": "Afwijzen",
  "act.aanvraag.goedgekeurd": "Aanvraag goedgekeurd; ingeschreven.",
  "act.aanvraag.afgewezen": "Aanvraag afgewezen.",
  "act.aanvraag.afgewezenom": "Afgewezen: {reden}",
  "inschrijving.fout.geen_aanvraag": "Hierover is al besloten.",
  "inschrijving.fout.reden_te_lang": "De toelichting is te lang (hooguit 500 tekens).",
  "inschrijving.fout.afmelden_via_club": "Afmelden kan nu alleen via de club.",
  "dossier.titel": "Sportief dossier",
  "dossier.uitleg.club": "Uitslagen die de club invoert, zijn direct bevestigd. Uitslagen van het lid of een ouder bevestig je hier, of je wijst ze af met een reden.",
  "dossier.uitleg.lid": "Voeg uitslagen toe met een bewijsstuk, zoals een uitslagenlijst of oorkonde. De club bevestigt ze. Een bevestigde uitslag kun je niet meer wijzigen.",
  "dossier.graduaties": "Graduaties",
  "dossier.graduaties.leeg": "Nog geen graduaties vastgelegd.",
  "dossier.graad.opgave": "Graad volgens de club: {graad}",
  "dossier.graad.bron.register": "register",
  "dossier.graad.bron.examen": "examen",
  "dossier.uitslagen": "Uitslagen",
  "dossier.uitslagen.leeg": "Nog geen uitslagen.",
  "dossier.open": "Te bevestigen: {aantal}",
  "dossier.nieuw": "Uitslag toevoegen",
  "dossier.wijzig": "Wijzigen",
  "dossier.status.bevestigd": "Bevestigd",
  "dossier.status.onbevestigd": "Niet bevestigd",
  "dossier.status.afgewezen": "Afgewezen",
  "dossier.bron.club": "Ingevoerd door de club",
  "dossier.bron.zelf": "Ingevoerd door het lid",
  "dossier.bron.ouder": "Ingevoerd door een ouder",
  "dossier.bron.import": "Geïmporteerd",
  "dossier.afgewezenom": "Afgewezen: {reden}",
  "dossier.klassering.geen": "Geen klassering",
  "dossier.klassering.plaats": "Plaats {plaats}",
  "dossier.niveau.club": "Club",
  "dossier.niveau.regionaal": "Regionaal",
  "dossier.niveau.nationaal": "Nationaal",
  "dossier.niveau.internationaal": "Internationaal",
  "dossier.onderdeel.tul": "Tul",
  "dossier.onderdeel.sparring": "Sparring",
  "dossier.onderdeel.speciale_techniek": "Speciale techniek",
  "dossier.onderdeel.breektest": "Breektest",
  "dossier.onderdeel.team_tul": "Team tul",
  "dossier.onderdeel.team_sparring": "Team sparring",
  "dossier.onderdeel.team_speciale_techniek": "Team speciale techniek",
  "dossier.onderdeel.team_breektest": "Team breektest",
  "dossier.onderdeel.overig": "Overig",
  "dossier.veld.datum": "Datum",
  "dossier.veld.toernooi": "Toernooi",
  "dossier.veld.toernooi.voorbeeld": "Bijvoorbeeld: Open Kampioenschap",
  "dossier.veld.stad": "Plaats",
  "dossier.veld.land": "Land (2 letters)",
  "dossier.veld.niveau": "Niveau",
  "dossier.veld.onderdeel": "Onderdeel",
  "dossier.veld.categorie": "Categorie",
  "dossier.veld.categorie.voorbeeld": "Bijvoorbeeld: junioren -55 kg",
  "dossier.veld.klassering": "Eindklassering",
  "dossier.veld.toelichting": "Toelichting",
  "dossier.veld.bewijs": "Bewijsstuk (optioneel)",
  "dossier.bewijs.uitleg": "Pdf, jpg of png, hooguit 10 MB. Alleen zichtbaar voor het lid, de ouder en de club.",
  "dossier.bewijs.toevoegen": "Bewijs",
  "dossier.bewijs.toegevoegd": "Bewijsstuk toegevoegd.",
  "dossier.bewijs.weg": "Bewijsstuk verwijderen",
  "dossier.bewijs.weg.vraag": "Dit bewijsstuk verwijderen?",
  "dossier.weg.vraag": "De uitslag {toernooi} met bewijsstukken verwijderen?",
  "dossier.verwijderd": "Uitslag verwijderd.",
  "dossier.opgeslagen": "Uitslag opgeslagen.",
  "dossier.opgeslagen.open": "Uitslag opgeslagen. De club bevestigt hem.",
  "dossier.bevestig": "Bevestigen",
  "dossier.afwijs": "Afwijzen",
  "dossier.afwijs.uitleg": "Het lid ziet de reden en kan de uitslag aanpassen.",
  "dossier.afwijs.voorbeeld": "Bijvoorbeeld: graag de uitslagenlijst erbij",
  "dossier.bevestigd": "Uitslag bevestigd.",
  "dossier.afgewezen": "Uitslag afgewezen.",
  "dossier.fout.geen_recht": "Je mag dit dossier niet zien of wijzigen.",
  "dossier.fout.onbekende_persoon": "Deze persoon bestaat niet (meer).",
  "dossier.fout.onbekende_uitslag": "Deze uitslag bestaat niet (meer).",
  "dossier.fout.datum_toekomst": "Een uitslag kan niet in de toekomst liggen.",
  "dossier.fout.vast": "Deze gegevens liggen vast.",
  "dossier.fout.besluit_via_functie": "Bevestigen of afwijzen gaat via de knoppen van de club.",
  "dossier.fout.bevestigd": "Een bevestigde uitslag wijzig je via de club.",
  "dossier.fout.geen_open_uitslag": "Over deze uitslag is al besloten.",
  "dossier.fout.reden_nodig": "Geef een reden voor het afwijzen.",
  "dossier.fout.reden_te_lang": "De reden is te lang (hooguit 500 tekens).",
  "dossier.fout.ongeldig_pad": "Dit bestand hoort niet bij deze persoon.",
  "dossier.fout.te_veel_bestanden": "Hooguit 5 bewijsstukken per uitslag.",
  "dossier.fout.bestandstype": "Alleen pdf, jpg of png.",
  "dossier.fout.bestand_te_groot": "Het bestand is groter dan 10 MB.",
  "dossier.fout.verplicht": "Datum en toernooi zijn verplicht.",
  "dossier.fout.land": "Land als twee letters, bijvoorbeeld NL of BE.",
  "nav.deelnemers": "Deelnemers",
  "nav.sporters": "Sportersregister",
  "titel.deelnemers": "Deelnemers",
  "titel.sporters": "Sportersregister",
  "dln.menu.titel": "Deelnemers-CSV",
  "dln.menu.sub": "Sporters en categorieën (competitor entries)",
  "dln.geeneditie": "Kies eerst een editie.",
  "dln.nietbeschikbaar": "Deelnemers zijn nog niet beschikbaar. Is de migratie voor sporters gedraaid?",
  "dln.kpi.sporters": "Sporters",
  "dln.kpi.deelnames": "Deelnames",
  "dln.kpi.clubs": "Clubs",
  "dln.kpi.landen": "Landen",
  "dln.kpi.minderjarig": "Onder 18",
  "dln.kpi.terugkerend": "Meer dan één editie",
  "dln.import": "Deelnemers importeren",
  "dln.toonafgemeld": "Toon afgemeld ({aantal})",
  "dln.uitleg": "Uit de Sportdata-export met deelnemers. Opnieuw importeren werkt bij en meldt af wie er niet meer in staat.",
  "dln.kol.naam": "Naam",
  "dln.kol.club": "Club",
  "dln.kol.land": "Land",
  "dln.kol.geslacht": "Geslacht",
  "dln.kol.leeftijd": "Leeftijd",
  "dln.kol.onderdeel": "Onderdeel",
  "dln.kol.categorie": "Categorie",
  "dln.kol.graad": "Graad",
  "dln.kol.laatsteclub": "Laatste club",
  "dln.kol.nationaliteit": "Nationaliteit",
  "dln.kol.edities": "Edities",
  "dln.kol.laatste": "Laatste editie",
  "dln.geslacht.m": "Man",
  "dln.geslacht.v": "Vrouw",
  "dln.geslacht.x": "Anders",
  "dln.graad.gup": "{n}e gup",
  "dln.graad.dan": "{n}e dan",
  "dln.afgemeld": "Afgemeld",
  "dln.zoek": "Zoek op naam, club of categorie",
  "dln.leeg": "Nog geen deelnemers voor deze editie. Importeer de deelnemers-CSV uit Sportdata.",
  "dln.register.uitleg": "Alle sporters die aan een toernooi van deze organisatie meededen, over alle edities heen. Een andere organisatie ziet ze niet.",
  "dln.register.leeg": "Nog geen sporters.",
  "dln.historie": "Deelnames ({aantal} edities)",
  "dln.historie.leeg": "Geen deelnames.",
  "dln.proef.titel": "Deelnemers importeren: {editie}",
  "dln.proef.sporters_nieuw": "Nieuwe sporters",
  "dln.proef.sporters_bijgewerkt": "Sporters bijgewerkt",
  "dln.proef.deelnames_nieuw": "Nieuwe deelnames",
  "dln.proef.deelnames_afgemeld": "Afgemeld",
  "dln.proef.totaal": "Na import: {sporters} sporters, {deelnames} deelnames, {clubs} clubs.",
  "dln.proef.afmeldwaarschuwing": "{aantal} deelnames staan niet meer in dit bestand en worden afgemeld. Klopt dat niet, dan is dit mogelijk een ander of onvolledig bestand.",
  "dln.proef.zonderbetaling": "Clubs zonder inschrijving in de betalingen van deze editie:",
  "dln.proef.zonderregister": "Clubs niet in het clubregister:",
  "dln.proef.fouten": "Overgeslagen of onvolledige regels: {aantal}",
  "dln.proef.weggelaten": "Niet overgenomen: {kolommen}.",
  "dln.proef.bevestig": "Importeren",
  "dln.rijfout": "regel {rij}: {fout}",
  "dln.rijfout.onvolledig": "sporter-ID, achternaam of categorie ontbreekt",
  "dln.rijfout.dubbel": "dubbele regel",
  "dln.rijfout.geboortedatum": "geen geldige geboortedatum",
  "dln.gelukt": "Geïmporteerd: {sporters} sporters, {deelnames} deelnames.",
  "dln.fout.geen_recht": "Je mag voor deze editie geen deelnemers importeren.",
  "dln.fout.leeg": "Het bestand bevat geen deelnemers.",
  "dln.fout.te_veel": "Hooguit 5000 regels per keer.",
  "dln.fout.formaat": "Dit is geen deelnemersexport van Sportdata (kolom Athlete ID ontbreekt).",
  "dln.kol.nationaalid": "Nationaal ID",
  "dln.nationaalid": "Nationaal ID {id}",
  "dln.internationaalid": "Internationaal ID {id}",
  "nav.aansluitingen": "Aansluitingen",
  "titel.aansluitingen": "Aansluitingen",
  "aans.titel.bond": "Aangesloten clubs",
  "aans.titel.club": "Mijn bond",
  "aans.uitleg.bond": "Clubs die zich bij jullie bond aansluiten, of die jullie zelf toevoegen. Bij goedkeuring wordt de club gekoppeld aan het clubregister.",
  "aans.uitleg.club": "Hier zie je bij welke bond je club is aangesloten of dat heeft aangevraagd. De bond beslist over een aanvraag.",
  "aans.status.aangevraagd": "Aangevraagd",
  "aans.status.in_gesprek": "In gesprek",
  "aans.status.actief": "Aangesloten",
  "aans.status.beeindigd": "Beëindigd",
  "aans.sectie.beoordelen": "Te beoordelen",
  "aans.sectie.actief": "Aangesloten",
  "aans.sectie.beeindigd": "Beëindigd",
  "aans.leeg": "Nog geen aansluitingen.",
  "aans.van": "Aangevraagd door {door} op {datum}",
  "aans.sinds": "Aangesloten sinds {datum}",
  "aans.tot": "Beëindigd op {datum}: {reden}",
  "aans.organisatie": "Organisatie {naam}",
  "aans.notitie": "Notitie (optioneel)",
  "aans.knop.ingesprek": "Zet in gesprek",
  "aans.knop.goedkeuren": "Goedkeuren",
  "aans.knop.afwijzen": "Afwijzen",
  "aans.knop.beeindigen": "Beëindigen",
  "aans.knop.intrekken": "Aanvraag intrekken",
  "aans.knop.aanvragen": "Aansluiting aanvragen",
  "aans.knop.toevoegen": "Toevoegen",
  "aans.knop.registerclub": "Aan register toevoegen",
  "aans.toevoegen.titel": "Club toevoegen",
  "aans.toevoegen.uitleg": "Voeg een club uit jullie register toe als aangesloten club, of zet hem eerst in gesprek.",
  "aans.toevoegen.club": "Club uit het register",
  "aans.toevoegen.status": "Status",
  "aans.toevoegen.geen": "Alle clubs in het register zijn al aangesloten of aangevraagd.",
  "aans.register.titel": "Club aan het register toevoegen",
  "aans.register.naam": "Naam van de club",
  "aans.register.plaats": "Plaats",
  "aans.aanvragen.titel": "Aansluiting aanvragen",
  "aans.aanvragen.bond": "Bond",
  "aans.aanvragen.geen": "Er zijn geen bonden beschikbaar om aan te vragen.",
  "aans.goedkeuren.titel": "Aanvraag goedkeuren",
  "aans.goedkeuren.uitleg": "Koppel {naam} aan het clubregister van jullie bond. Alleen jullie kiezen welke registerclub het wordt.",
  "aans.goedkeuren.nieuw": "Nieuwe club in het register aanmaken ({naam})",
  "aans.goedkeuren.bestaand": "Koppelen aan een club die al in het register staat",
  "aans.afwijzen.titel": "Aanvraag afwijzen",
  "aans.afwijzen.uitleg": "De club ziet de reden bij de aanvraag.",
  "aans.beeindigen.titel": "Aansluiting beëindigen",
  "aans.beeindigen.uitleg.bond": "De aansluiting eindigt vandaag. De gevolgen voor de leden regel je voorlopig zelf; de reden staat in het auditlog.",
  "aans.beeindigen.uitleg.club": "De aansluiting bij deze bond eindigt vandaag. De bond ziet de reden.",
  "aans.reden.voorbeeld": "Bijvoorbeeld: club stopt of stapt over",
  "aans.aangevraagd": "Aansluiting aangevraagd",
  "aans.goedgekeurd": "Club aangesloten",
  "aans.afgewezen": "Aanvraag afgewezen",
  "aans.beeindigd": "Aansluiting beëindigd",
  "aans.nietbeschikbaar": "Aansluitingen zijn nog niet beschikbaar. Draai de migratie voor aansluitingen.",
  "aans.fout.geen_toegang": "Daar heb je geen rechten voor.",
  "aans.fout.geen_club": "Alleen een club kan zich aansluiten.",
  "aans.fout.geen_bond": "Deze organisatie is geen bond.",
  "aans.fout.bestaat_al": "Er is al een lopende aansluiting met deze bond.",
  "aans.fout.club_onbekend": "Deze club staat niet in het register.",
  "aans.fout.status": "Dit kan niet meer met de huidige status van de aansluiting.",
  "aans.fout.reden_nodig": "Een reden is verplicht.",
  "aans.fout.club_al_gekoppeld": "Deze registerclub is al aan een andere organisatie gekoppeld.",
  "aans.fout.bestaat_al_of_naam_bezet": "Er bestaat al een aansluiting of een club met deze naam.",
  "aans.fout.einddatum_voor_start": "De einddatum ligt voor de startdatum.",
  "aans.fout.naam_bezet": "Deze club staat al in het register.",
  "bond.nummer": "{label} {nummer}",
  "bond.nummer.standaard": "Nummer",
  "bond.schaal.kies": "Schaal uit de catalogus",
  "bond.schaal.kies.knop": "Schaal kiezen",
  "bond.soort.nummerlabel": "Naam van het nummer (optioneel)",
  "bond.soort.nummerlabel.voorbeeld": "Bijvoorbeeld Plaquenummer",
  "bond.soort.verplicht": "Nummer verplicht",
  "bond.soort.metnummer": "met {label}",
  "schaal.fout.geen_toegang": "Alleen de owner van een bond kiest een schaal.",
  "schaal.fout.schaal_onbekend": "Deze schaal bestaat niet of is niet actief.",
  "schaal.fout.eigen_schaal_actief": "Je bond heeft een eigen schaal. Die gaat voor een schaal uit de catalogus.",
  "schaal.fout.graden_in_gebruik": "Er zijn graduaties die niet in deze schaal passen. Wissel pas als die kloppen.",
  "dispatch.fout.nummer_niet_toegestaan": "Deze graad of licentiesoort heeft geen nummer.",
  "dispatch.fout.nummer_bezet": "Dit nummer is al aan iemand anders toegekend.",
  "dispatch.fout.nummer_nodig": "Voor deze licentiesoort is een nummer verplicht.",
  "nav.verzoeken": "Verzoeken",
  "titel.verzoeken": "Verzoeken",
  "verz.titel": "Verzoeken",
  "verz.uitleg.org": "Verzoeken tussen leden, clubs en de bond. Elk verzoek heeft een eigen gesprek met een vaste status.",
  "verz.uitleg.bond": "Verzoeken van clubs en leden aan uw bond. Berichten kunnen alleen worden aangevuld, nooit gewijzigd.",
  "verz.uitleg.club": "Verzoeken van uw leden en uw club aan de bond. Berichten kunnen alleen worden aangevuld, nooit gewijzigd.",
  "verz.uitleg.lid": "Hier kunt u een verzoek indienen bij uw bond of club en het gesprek volgen.",
  "verz.leeg": "Er zijn nog geen verzoeken.",
  "verz.sectie.afgehandeld": "Afgehandeld",
  "verz.laatste": "Laatste bericht {datum}",
  "verz.nieuw": "Nieuw",
  "verz.wacht.opu": "Wacht op u",
  "verz.wacht.op": "Wachten op",
  "verz.wacht.termijn": "Termijn (optioneel)",
  "verz.wacht.status": "Wacht op {partij}",
  "verz.termijn": "Termijn: {datum}",
  "verz.meekijken": "U kijkt mee met dit verzoek als beheerder. U kunt niet namens een partij reageren.",
  "verz.opmerking": "Opmerking (optioneel)",
  "verz.veld.met": "Verzoek aan",
  "verz.veld.type": "Soort verzoek",
  "verz.veld.onderwerp": "Onderwerp",
  "verz.veld.bericht": "Bericht",
  "verz.veld.zichtbaarheid": "Zichtbaar voor",
  "verz.veld.antwoord": "Schrijf een bericht",
  "verz.veld.als": "Reageren als",
  "verz.veld.namens": "Namens",
  "verz.zicht.uitleg": "Bepaalt wie dit bericht kan lezen. Een bericht kan achteraf niet meer worden aangepast.",
  "verz.zicht.iedereen": "Alle betrokkenen",
  "verz.zicht.club_bond": "Alleen club en bond",
  "verz.zicht.eigen": "Alleen mijn eigen partij",
  "verz.namens.nee": "Voor mezelf",
  "verz.namens.optie": "Namens {partij}",
  "verz.namens.bericht": "Geplaatst namens {partij}",
  "verz.knop.nieuw": "Nieuw verzoek",
  "verz.knop.openen": "Verzoek indienen",
  "verz.knop.terug": "Terug naar overzicht",
  "verz.knop.wachten": "Wachten op reactie",
  "verz.knop.afhandelen": "Afhandelen",
  "verz.knop.heropenen": "Heropenen",
  "verz.knop.escaleren": "Escaleren",
  "verz.knop.versturen": "Versturen",
  "verz.knop.opnieuw": "Weer oppakken",
  "verz.wachten.titel": "Wachten op reactie",
  "verz.wachten.uitleg": "Kies van wie u een reactie verwacht en stel eventueel een termijn in. Het verzoek blijft open.",
  "verz.afhandelen.titel": "Verzoek afhandelen",
  "verz.afhandelen.uitleg": "Het verzoek wordt gesloten. De bond kan het later heropenen.",
  "verz.escaleren.titel": "Verzoek escaleren",
  "verz.escaleren.uitleg": "Markeer dit verzoek als vastgelopen, zodat de bond het ziet en kan oppakken.",
  "verz.heropenen.titel": "Verzoek heropenen",
  "verz.heropenen.uitleg": "Het verzoek wordt weer geopend en de betrokkenen zien dit.",
  "verz.partij.lid": "het lid",
  "verz.partij.club": "de club",
  "verz.partij.bond": "de bond",
  "verz.partij.systeem": "het systeem",
  "verz.status.open": "Open",
  "verz.status.wacht_op_reactie": "Wacht op reactie",
  "verz.status.afgehandeld": "Afgehandeld",
  "verz.status.geescaleerd": "Geëscaleerd",
  "verz.type.aansluiting": "Aansluiting",
  "verz.type.opzegging": "Opzegging",
  "verz.type.overstap": "Overstap",
  "verz.type.vrijstelling": "Vrijstelling",
  "verz.type.geschil": "Geschil",
  "verz.type.overig": "Overig",
  "verz.log.afgehandeld": "{partij} heeft het verzoek afgehandeld.",
  "verz.log.geescaleerd": "{partij} heeft het verzoek geëscaleerd.",
  "verz.log.wacht": "{partij} wacht op een reactie van {wacht}.",
  "verz.log.termijn": "Termijn: {datum}.",
  "verz.log.heropend": "{partij} heeft het verzoek heropend.",
  "verz.log.open": "{partij} heeft het verzoek geopend.",
  "verz.geopend": "Verzoek ingediend.",
  "verz.nietbeschikbaar": "Verzoeken zijn voor deze organisatie niet beschikbaar.",
  "verz.fout.geen_toegang": "U heeft geen toegang tot dit verzoek.",
  "verz.fout.onbekend_type": "Onbekend soort verzoek.",
  "verz.fout.onderwerp_nodig": "Vul een onderwerp in.",
  "verz.fout.bericht_nodig": "Vul een bericht in.",
  "verz.fout.geen_bond": "De gekozen organisatie is geen bond.",
  "verz.fout.geen_aansluiting": "Er is geen aansluiting tussen deze club en de bond.",
  "verz.fout.club_klopt_niet": "De gekozen club hoort niet bij dit verzoek.",
  "verz.fout.persoon_klopt_niet": "De gekozen persoon hoort niet bij dit verzoek.",
  "verz.fout.onderwerp_ontbreekt": "Vul een onderwerp in.",
  "verz.fout.zichtbaarheid": "Deze zichtbaarheid is niet toegestaan.",
  "verz.fout.partij_kiezen": "Kies namens welke partij u reageert.",
  "verz.fout.afgehandeld": "Dit verzoek is afgehandeld. Heropen het om te reageren.",
  "verz.fout.namens_niet_mogelijk": "U kunt niet namens deze partij reageren.",
  "verz.fout.geen_recht_status": "U mag de status van dit verzoek niet wijzigen.",
  "verz.fout.ongeldige_status": "Deze statuswijziging is niet mogelijk.",
  "verz.fout.wacht_op_nodig": "Kies van wie u een reactie verwacht.",
  "verz.fout.geen_wijziging": "Het verzoek heeft die status al.",
  "verz.fout.alleen_aanvullen": "Berichten kunnen niet worden gewijzigd of verwijderd.",
  "leden.kol.club": "Club",
  "leden.club": "Club",
  "leden.club.kies": "Kies een club",
  "leden.club.geen": "Nog geen club",
  "leden.club.wissel": "Van club wisselen kan alleen via een overstap met toestemming van beide clubs.",
  "leden.club.nodig": "Bij een bond hoort elk lid bij een club uit het clubregister.",
  "leden.club.leeg": "Het clubregister is nog leeg. Voeg eerst clubs toe bij Bond.",
  "leden.club.vrijstelling.grand_master": "Vrijgesteld van een club: Grand Master",
  "leden.club.vrijstelling.maatwerk": "Vrijgesteld van een club: maatwerk",
  "lidm.werklijst.knop": "Leden zonder club ({aantal})",
  "lidm.werklijst.banner": "{aantal} leden hebben nog geen club. Koppel ze aan een club uit het register.",
  "lidm.werklijst.titel": "Leden zonder club",
  "lidm.werklijst.uitleg": "Deze leden komen uit een import of uit het oude systeem. Per groep kiest u de club uit het register. Leden die al bij een andere club staan, blijven staan: een tweede club vraagt een besluit.",
  "lidm.werklijst.geen": "Alle leden hebben een club of een vrijstelling.",
  "lidm.werklijst.groep": "{naam}: {aantal} leden",
  "lidm.werklijst.zonderSleutel": "Zonder clubnaam",
  "lidm.werklijst.bron": "Bron: {systeem}, sleutel {sleutel}",
  "lidm.werklijst.kies": "Kies een club",
  "lidm.werklijst.koppel": "Koppelen",
  "lidm.werklijst.auto": "Automatisch koppelen",
  "lidm.werklijst.autoUitleg": "Koppelt alle leden waarvan de clubsleutel al bij een club in het register staat.",
  "lidm.werklijst.gekoppeld": "{aantal} leden gekoppeld.",
  "lidm.werklijst.niets": "Er is niets gekoppeld.",
  "lidm.fout.club_onbekend": "Deze club staat niet (meer) actief in het register van deze bond.",
  "lidm.fout.vrijstelling_via_dispatcher": "Een vrijstelling zet u via een voorstel met goedkeuring, niet rechtstreeks.",
  "lidm.fout.club_wissel_via_overstap": "Van club wisselen kan alleen via een overstap.",
  "lidm.fout.overgang_door_systeem": "De overgangsperiode wordt door het systeem gezet.",
  "lidm.fout.tweede_club": "Dit lid staat al bij een andere club. Een tweede club vraagt een besluit.",
  "lidm.fout.club_nodig": "Kies een club uit het register. Alleen een Grand Master of maatwerk kan zonder club.",
  "lidm.fout.geen_recht": "U mag leden niet aan een club koppelen.",
  "lidm.fout.sleutel_nodig": "Dit lid heeft geen clubnaam of sleutel om op te koppelen.",
  "import.club": "Club van de geïmporteerde leden",
  "import.club.uitleg": "Alle leden uit dit bestand komen bij deze club.",
  "import.club.nodig": "Kies eerst een club.",
  "dispatch.fout.heeft_club": "Dit lid heeft al een club en kan niet worden vrijgesteld.",
  "dispatch.fout.al_vrijgesteld": "Dit lid is al vrijgesteld.",
  "dispatch.fout.niet_vrijgesteld": "Dit lid is niet vrijgesteld.",
  "dispatch.fout.onbekende_soort": "Kies Grand Master of maatwerk.",
  "vierogen.handeling.member.exempt": "Vrijstelling van de clubplicht",
  "vierogen.handeling.member.unexempt": "Vrijstelling van de clubplicht opheffen",
  "bond.vrijstelling": "Clubplicht",
  "bond.vrijstelling.uitleg": "Een lid van een bond hoort bij een club. Een Grand Master of een lid met maatwerk kan zonder club. Dat stelt u voor met een reden en een tweede persoon keurt het goed.",
  "bond.vrijstelling.geen": "Geen vrijstelling nodig: dit lid heeft een club.",
  "bond.vrijstelling.club": "Club: {club}",
  "bond.vrijstelling.soort": "Soort vrijstelling",
  "bond.vrijstelling.grand_master": "Grand Master",
  "bond.vrijstelling.maatwerk": "Maatwerk",
  "bond.vrijstelling.nu": "Vrijgesteld: {soort}",
  "bond.vrijstelling.opheffen": "Vrijstelling opheffen",
  "bond.vrijstelling.vrijstellen": "Vrijstelling voorstellen",
  "bond.vrijstelling.geenlidmaatschap": "Dit lid heeft geen actief lidmaatschap.",
  "lidm.titel": "Uw lidmaatschap",
  "lidm.uitleg": "Hier ziet u bij welke club en bond u staat. Opzeggen, overstappen of een tweede club vraagt om instemming van de betrokken partijen. U volgt de stand hieronder.",
  "lidm.club": "Club: {club}",
  "lidm.geenClub": "Geen club",
  "lidm.sinds": "lid sinds {datum}",
  "lidm.eindigt": "eindigt op {datum}",
  "lidm.overgang": "U heeft tot {datum} om een nieuwe club te kiezen. Daarna wordt uw lidmaatschap beëindigd.",
  "lidm.lopend": "Er loopt al een wijziging",
  "lidm.knop.opzeggen": "Opzeggen",
  "lidm.knop.overstappen": "Overstappen",
  "lidm.knop.tweede": "Tweede club",
  "lidm.knop.indienen": "Indienen",
  "lidm.knop.akkoord": "Akkoord",
  "lidm.knop.bezwaar": "Bezwaar",
  "lidm.knop.doorzetten": "Toch doorzetten",
  "lidm.knop.afwijzen": "Afwijzen",
  "lidm.knop.intrekken": "Intrekken",
  "lidm.aanvraag.titel.opzegging": "Lidmaatschap opzeggen",
  "lidm.aanvraag.titel.overstap": "Overstappen naar een andere club",
  "lidm.aanvraag.titel.tweede_club": "Tweede club toevoegen",
  "lidm.aanvraag.uitleg.opzegging": "De club en de bond krijgen bericht. Reageert de club niet binnen 14 dagen, dan krijgt zij een herinnering en beslist de bond. Het lidmaatschap eindigt op de gekozen datum.",
  "lidm.aanvraag.uitleg.overstap": "De huidige en de nieuwe club krijgen bericht. Reageert de huidige club niet binnen 14 dagen, dan krijgt zij een herinnering en beslist de bond. De nieuwe club stemt altijd zelf in. Op de gekozen datum wisselt het lidmaatschap van club.",
  "lidm.aanvraag.uitleg.tweede_club": "De huidige en de nieuwe club krijgen bericht. Na instemming staat het lid bij beide clubs.",
  "lidm.veld.club": "Nieuwe club",
  "lidm.veld.datum": "Ingangsdatum",
  "lidm.veld.toelichting": "Toelichting",
  "lidm.actie.opzegging": "Opzegging",
  "lidm.actie.overstap": "Overstap",
  "lidm.actie.tweede_club": "Tweede club",
  "lidm.van": "van {club}",
  "lidm.naar": "naar {club}",
  "lidm.per": "per {datum}",
  "lidm.status.open": "Wacht op besluit",
  "lidm.status.akkoord": "Ingepland",
  "lidm.status.uitgevoerd": "Uitgevoerd",
  "lidm.status.afgewezen": "Afgewezen",
  "lidm.status.verlopen": "Vervallen",
  "lidm.wacht.datum": "Alle partijen zijn akkoord. De wijziging gaat in op {datum}.",
  "lidm.termijn": "Zonder reactie vervalt dit verzoek na {datum}.",
  "lidm.escalatie": "Er is bezwaar gemaakt. De bond beslist.",
  "lidm.rol.lid": "Lid",
  "lidm.rol.van_club": "Huidige club",
  "lidm.rol.naar_club": "Nieuwe club",
  "lidm.rolstatus.wacht": "wacht op reactie",
  "lidm.rolstatus.akkoord": "akkoord",
  "lidm.rolstatus.bezwaar": "bezwaar",
  "lidm.rol.stilzwijgend": "stilzwijgend",
  "lidm.rol.stilzwijgendVanaf": "stilzwijgend akkoord vanaf {datum}",
  "lidm.rol.namens": "door de bond namens deze partij",
  "lidm.bezwaar.titel": "Bezwaar maken",
  "lidm.bezwaar.uitleg": "Bij bezwaar beslist de bond. Leg kort uit waarom u bezwaar maakt.",
  "lidm.bezwaar.veld": "Reden van het bezwaar",
  "lidm.bond.titel": "Besluit van de bond",
  "lidm.bond.uitleg": "Er is bezwaar gemaakt. Uw besluit en toelichting zijn zichtbaar voor alle betrokken partijen.",
  "lidm.bond.veld": "Toelichting bij het besluit",
  "lidm.ingediend": "Het verzoek is ingediend.",
  "lidm.besloten": "Uw besluit is vastgelegd.",
  "lidm.ingetrokken": "Het verzoek is ingetrokken.",
  "lidm.sectie.afgerond": "Recent afgerond",
  "lidm.sectie.wacht": "Wacht op uw besluit",
  "lidm.log.aangevraagd": "{partij} heeft een wijziging aangevraagd per {datum}.",
  "lidm.log.akkoord": "Alle partijen zijn akkoord. De wijziging gaat in op {datum}.",
  "lidm.log.uitgevoerd": "De wijziging is uitgevoerd.",
  "lidm.log.afgewezen": "Het verzoek is afgewezen. {reden}",
  "lidm.log.verlopen": "Het verzoek is vervallen. {reden}",
  "lidm.log.rolakkoord": "{partij} is akkoord ({rol}).",
  "lidm.log.bezwaar": "{partij} heeft bezwaar gemaakt ({rol}).",
  "lidm.log.stilzwijgend": "Er kwam geen reactie binnen de termijn.",
  "lidm.log.namens": "Door de bond namens deze partij vastgelegd.",
  "lidm.log.bond.doorgezet": "{partij} heeft besloten de wijziging door te zetten.",
  "lidm.log.bond.afgewezen": "{partij} heeft de wijziging afgewezen.",
  "lidm.reden.ingetrokken": "Ingetrokken door de aanvrager.",
  "lidm.reden.bezwaar": "Er is bezwaar gemaakt.",
  "lidm.reden.bond": "Besluit van de bond.",
  "lidm.reden.termijn": "De termijn van 30 dagen is verstreken.",
  "lidm.reden.lidmaatschap_gewijzigd": "Het lidmaatschap is in de tussentijd gewijzigd.",
  "lidm.reden.club_niet_meer_actief": "De club is niet meer actief in het register.",
  "lidm.fout.geen_toegang": "U heeft hiervoor geen toegang.",
  "lidm.fout.onbekend": "Dit lidmaatschap is niet gevonden.",
  "lidm.fout.niet_actief": "Dit lidmaatschap is niet actief.",
  "lidm.fout.geen_bond": "Dit lidmaatschap hoort niet bij een bond met een clubregister.",
  "lidm.fout.onbekende_actie": "Onbekende soort wijziging.",
  "lidm.fout.datum_ongeldig": "Kies een datum vanaf vandaag en binnen een jaar.",
  "lidm.fout.al_lopend": "Er loopt al een wijziging voor dit lidmaatschap.",
  "lidm.fout.vrijgesteld": "Dit lid is vrijgesteld van een club. Een overstap is niet van toepassing.",
  "lidm.fout.geen_club": "Dit lid heeft geen club.",
  "lidm.fout.zelfde_club": "Dit is al de huidige club.",
  "lidm.fout.al_lid": "Dit lid staat al bij deze club.",
  "lidm.fout.partij_kiezen": "Kies namens welke partij u indient.",
  "lidm.fout.toelichting_nodig": "Een toelichting is verplicht, en mag niet langer zijn dan 4000 tekens.",
  "lidm.fout.rol_onbekend": "Deze partij hoort niet bij dit verzoek.",
  "lidm.fout.al_besloten": "Deze partij heeft al besloten.",
  "lidm.fout.niet_open": "Dit verzoek loopt niet meer.",
  "lidm.fout.geescaleerd": "Er is bezwaar gemaakt. De bond beslist.",
  "lidm.fout.niet_geescaleerd": "Dit verzoek ligt niet bij de bond.",
  "nav.clubregister": "Clubs",
  "titel.clubregister": "Clubregister",
  "clubreg.titel": "Clubregister",
  "clubreg.uitleg": "Alle clubs van uw bond. Dit register is de bron voor de clubkeuze bij een lid. Een club verwijderen kan niet, wel archiveren zodra er geen leden meer bij horen.",
  "clubreg.zoek": "Zoek op naam, plaats of code",
  "clubreg.filter.actief": "Actief",
  "clubreg.filter.gearchiveerd": "Gearchiveerd",
  "clubreg.filter.alle": "Alle",
  "clubreg.kol.naam": "Club",
  "clubreg.kol.code": "Code",
  "clubreg.kol.plaats": "Plaats",
  "clubreg.kol.leden": "Leden",
  "clubreg.kol.aansluiting": "Aansluiting",
  "clubreg.kol.status": "Status",
  "clubreg.aansluiting.geen": "Niet aangesloten",
  "clubreg.status.gearchiveerd": "Gearchiveerd",
  "clubreg.leeg": "Het clubregister is nog leeg. Voeg een club toe.",
  "clubreg.geen": "Geen clubs gevonden.",
  "clubreg.aantal": "{aantal} clubs",
  "clubreg.nietbeschikbaar": "Het clubregister is niet beschikbaar voor deze organisatie.",
  "clubreg.knop.toevoegen": "Club toevoegen",
  "clubreg.knop.opslaan": "Opslaan",
  "clubreg.knop.archiveren": "Archiveren",
  "clubreg.knop.herstellen": "Herstellen",
  "clubreg.nieuw.titel": "Club toevoegen",
  "clubreg.veld.naam": "Naam van de club",
  "clubreg.veld.plaats": "Plaats",
  "clubreg.veld.land": "Land (code)",
  "clubreg.veld.email": "E-mailadres van de club",
  "clubreg.geclaimd": "Deze club heeft een eigen Tornema-omgeving.",
  "clubreg.leden.titel": "Leden ({aantal})",
  "clubreg.leden.geen": "Er horen nog geen leden bij deze club.",
  "clubreg.toegevoegd": "De club is toegevoegd.",
  "clubreg.opgeslagen": "De club is opgeslagen.",
  "clubreg.gearchiveerd": "De club is gearchiveerd.",
  "clubreg.hersteld": "De club is hersteld.",
  "clubreg.fout.dubbel": "Er staat al een actieve club met deze naam in het register.",
  "clubreg.fout.naam": "Vul de naam van de club in.",
  "clubreg.fout.land": "Het land is een code van twee letters, bijvoorbeeld NL.",
  "clubreg.fout.leden": "Deze club heeft nog {aantal} leden. Archiveren kan pas als er geen leden meer bij horen.",
  "lidm.aanvraag.uitlegStil.opzegging": "De club en de bond krijgen bericht. Reageert de club niet binnen 14 dagen, dan geldt dat als akkoord. Het lidmaatschap eindigt op de gekozen datum.",
  "lidm.aanvraag.uitlegStil.overstap": "De huidige en de nieuwe club krijgen bericht. Reageert de huidige club niet binnen 14 dagen, dan geldt dat als akkoord. De nieuwe club stemt altijd zelf in. Op de gekozen datum wisselt het lidmaatschap van club.",
  "lidm.rol.herinneringVanaf": "zonder reactie herinnering op {datum}, daarna beslist de bond",
  "lidm.rol.herinnerd": "herinnerd op {datum}",
  "lidm.bondtaak": "De termijn van 14 dagen is verstreken. Er is een herinnering verstuurd. Reageert de partij niet, dan beslist de bond. Tot die tijd blijft het verzoek open.",
  "lidm.bond.uitlegTaak": "Een partij heeft niet binnen 14 dagen gereageerd. U beslist voor die partij. Het lid bij een overstap en de nieuwe club stemmen altijd zelf in. Uw besluit en toelichting zijn zichtbaar voor alle betrokken partijen.",
  "lidm.log.herinnering": "Geen reactie binnen 14 dagen ({rol}). Er is een herinnering verstuurd; de bond beslist als er geen reactie komt.",
  "lidm.fout.onderbouwing_nodig": "Een onderbouwing van minstens 20 tekens is verplicht: wanneer de meldingen end-to-end zijn getest en welk juridisch akkoord er is.",
  "clubleden.knop": "Leden bij de bond ({aantal})",
  "clubleden.titel": "Leden bij de bond",
  "clubleden.uitleg": "Deze leden staan bij de bond ingeschreven bij uw club. Hun gegevens staan op één persoonsrecord bij de bond; u ziet ze zolang ze bij uw club staan. Een opzegging of overstap vraagt een toelichting. Het lid wordt gehoord, en bij een overstap ook de nieuwe club.",
  "clubleden.leeg": "Er staan bij de bond geen leden bij uw club.",
  "import.doel.club": "Club (koppelen aan het clubregister)",
  "import.clubs.titel": "Clubs uit het bestand",
  "import.clubs.uitleg": "Per schrijfwijze in het bestand de club uit het register. Gevonden clubs zijn al gekozen. Een voorstel geldt pas als u het bevestigt. Wat u niet koppelt, komt op de werklijst Leden zonder club; de import gaat gewoon door.",
  "import.clubs.kol.bestand": "In het bestand",
  "import.clubs.kol.leden": "Leden",
  "import.clubs.kol.club": "Club in het register",
  "import.clubs.kol.stand": "Stand",
  "import.clubs.leeg": "(geen club ingevuld)",
  "import.clubs.werklijst": "Nog te koppelen (werklijst)",
  "import.clubs.lijktOp": "Lijkt op",
  "import.clubs.bevestig": "Bevestigen",
  "import.clubs.status.exact": "Gevonden",
  "import.clubs.status.voorstel": "Voorstel",
  "import.clubs.status.keuze": "Meerdere clubs, kies er een",
  "import.clubs.status.onbekend": "Niet gevonden",
  "import.klaar.werklijst": "{aantal} leden staan nog zonder club op de werklijst Leden zonder club. Koppel ze daar per groep.",
  "lidm.fout.import_ongeldig": "De import kon niet worden verwerkt: te veel regels in één keer of een clubnaam langer dan 200 tekens.",
  "leden.verzoek.knop": "Verzoek openen over dit lid",
  "leden.verzoek.titel": "Verzoek over {naam}",
  "leden.verzoek.uitleg": "Het verzoek gaat over dit lid en, als het lid een club heeft, ook naar die club. Een opzegging of overstap start u in het ledenformulier.",
  "verz.teller": "{aantal} wachten op u",
};
